// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://${string}/api` | (string & {})
}

/**
 * AccountBalanceOut
 */
export type AccountBalanceOut = {
  /**
   * Active
   */
  active: number
  /**
   * Usable
   */
  usable: number
}

/**
 * AccountBalancesOut
 */
export type AccountBalancesOut = {
  /**
   * Items
   */
  items: Array<AccountBalancesOutItem>
}

/**
 * AccountBalancesOutItem
 */
export type AccountBalancesOutItem = {
  /**
   * Active
   */
  active: number
  /**
   * Usable
   */
  usable: number
  /**
   * User Id
   */
  user_id: string
}

/**
 * AdminAddCommentTypeEnum
 *
 * Using for admin actions
 */
export const AdminAddCommentTypeEnum = {
  APPRECIATION: 'APPRECIATION',
  CONGRATULATIONS: 'CONGRATULATIONS',
  HIGH_QUALITY_WORK: 'HIGH_QUALITY_WORK',
  MENTORSHIP: 'MENTORSHIP',
  REWARD: 'REWARD',
  CORRECTION: 'CORRECTION',
  ENCOURAGEMENT: 'ENCOURAGEMENT',
} as const

/**
 * AdminAddCommentTypeEnum
 *
 * Using for admin actions
 */
export type AdminAddCommentTypeEnum = (typeof AdminAddCommentTypeEnum)[keyof typeof AdminAddCommentTypeEnum]

/**
 * AdminDebitCommentTypeEnum
 *
 * Using for admin debit actions
 */
export const AdminDebitCommentTypeEnum = { CORRECTION: 'CORRECTION' } as const

/**
 * AdminDebitCommentTypeEnum
 *
 * Using for admin debit actions
 */
export type AdminDebitCommentTypeEnum = (typeof AdminDebitCommentTypeEnum)[keyof typeof AdminDebitCommentTypeEnum]

/**
 * AssertEnum
 */
export const AssertEnum = { ACTIVE: 'ACTIVE', USABLE: 'USABLE' } as const

/**
 * AssertEnum
 */
export type AssertEnum = (typeof AssertEnum)[keyof typeof AssertEnum]

/**
 * AttributeGroupIn
 */
export type AttributeGroupIn = {
  /**
   * Id
   */
  id?: number | null
  /**
   * Name
   */
  name?: string | null
  /**
   * Values
   */
  values: Array<ProductValueIn>
}

/**
 * AttributeGroupOut
 */
export type AttributeGroupOut = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
  /**
   * Values
   */
  values: Array<ProductValueOut>
}

/**
 * AvatarIn
 */
export type AvatarIn = {
  /**
   * Attachments
   */
  attachments?: Array<string>
}

/**
 * BillingHistoryOut
 */
export type BillingHistoryOut = {
  /**
   * Records
   */
  records: Array<BillingHistoryRecordOut>
}

/**
 * BillingHistoryRecordOut
 */
export type BillingHistoryRecordOut = {
  /**
   * Datetime
   */
  datetime: string
  /**
   * Amount
   */
  amount: number
  type: TransactionTypeEnum
  coin_type: AssertEnum
  /**
   * Interaction Id
   */
  interaction_id: string | string
  /**
   * Comment
   */
  comment?: string | null
  comment_type?: DbCommentTypeEnum | null
  /**
   * Task Link
   */
  task_link?: string | null
}

/**
 * Birthday
 */
export type Birthday = {
  /**
   * Day
   */
  day: number
  /**
   * Month
   */
  month: number
}

/**
 * Body_import_confirm_account_balance_import_confirm_post
 */
export type BodyImportConfirmAccountBalanceImportConfirmPost = {
  /**
   * File
   */
  file: Blob | File
}

/**
 * Body_import_employees_passport_idm_IdmPrivate_ImportEmployees_post
 */
export type BodyImportEmployeesPassportIdmIdmPrivateImportEmployeesPost = {
  /**
   * File
   */
  file: Blob | File
}

/**
 * Body_import_validate_account_balance_import_validate_post
 */
export type BodyImportValidateAccountBalanceImportValidatePost = {
  /**
   * File
   */
  file: Blob | File
}

/**
 * Body_send_feedback_feedback_send_post
 */
export type BodySendFeedbackFeedbackSendPost = {
  /**
   * Email
   */
  email: string
  /**
   * Category Id
   */
  category_id: number
  /**
   * Subject
   */
  subject: string
  /**
   * Text
   */
  text: string
  /**
   * Attachment 1
   */
  attachment_1?: Blob | File | null
  /**
   * Attachment 2
   */
  attachment_2?: Blob | File | null
  /**
   * Attachment 3
   */
  attachment_3?: Blob | File | null
  /**
   * Attachment 4
   */
  attachment_4?: Blob | File | null
  /**
   * Attachment 5
   */
  attachment_5?: Blob | File | null
}

/**
 * Body_upload_image_media_upload_post
 */
export type BodyUploadImageMediaUploadPost = {
  /**
   * File
   */
  file: Blob | File
  /**
   * File type
   */
  file_type: FileTypeEnum
}

/**
 * BonusNameEnum
 */
export const BonusNameEnum = {
  ANNIVERSARY_BONUS: 'ANNIVERSARY_BONUS',
  BIRTHDAY_BONUS: 'BIRTHDAY_BONUS',
  CHRISTMAS_BONUS: 'CHRISTMAS_BONUS',
  MONTHLY_REFILL_HEADS: 'MONTHLY_REFILL_HEADS',
  MONTHLY_REFILL_EMPLOYEES: 'MONTHLY_REFILL_EMPLOYEES',
  WELCOME_BONUS: 'WELCOME_BONUS',
} as const

/**
 * BonusNameEnum
 */
export type BonusNameEnum = (typeof BonusNameEnum)[keyof typeof BonusNameEnum]

/**
 * BrandConfigIn
 */
export type BrandConfigIn = {
  /**
   * Id
   */
  id: string
  /**
   * Logo Image
   */
  logo_image: string
  /**
   * Favicon Image
   */
  favicon_image: string
  /**
   * Sign In Banner Image
   */
  sign_in_banner_image: string
  /**
   * Currency Symbol Image
   */
  currency_symbol_image: string
  /**
   * Banner Modal Background Image
   */
  banner_modal_background_image: string
  /**
   * Thanks Modal Background Image
   */
  thanks_modal_background_image: string
}

/**
 * BrandConfigOut
 */
export type BrandConfigOut = {
  /**
   * Id
   */
  id: string
  /**
   * Logo Image
   */
  logo_image: string
  /**
   * Favicon Image
   */
  favicon_image: string
  /**
   * Sign In Banner Image
   */
  sign_in_banner_image: string
  /**
   * Currency Symbol Image
   */
  currency_symbol_image: string
  /**
   * Banner Modal Background Image
   */
  banner_modal_background_image: string
  /**
   * Thanks Modal Background Image
   */
  thanks_modal_background_image: string
}

/**
 * BulkCoinsAddIn
 */
export type BulkCoinsAddIn = {
  /**
   * Amount
   */
  amount?: number
  assert_type: AssertEnum
  /**
   * Comment
   */
  comment: string
  comment_type: AdminAddCommentTypeEnum
}

/**
 * CitiesOut
 */
export type CitiesOut = {
  /**
   * Cities
   */
  cities: Array<CityOut>
}

/**
 * CitiesOutInfo
 */
export type CitiesOutInfo = {
  /**
   * Cities
   */
  cities: Array<CityOutInfo>
}

/**
 * CityInCreate
 */
export type CityInCreate = {
  /**
   * Name
   */
  name: string
  /**
   * Countryid
   */
  countryId: string
}

/**
 * CityInUpdate
 */
export type CityInUpdate = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  /**
   * Countryid
   */
  countryId: string
}

/**
 * CityInfoFilter
 */
export type CityInfoFilter = {
  /**
   * Ids
   */
  ids?: Array<string>
  /**
   * Countryid
   */
  countryId?: string | null
}

/**
 * CityInfoRequest
 */
export type CityInfoRequest = {
  filter: CityInfoFilter
  /**
   * Is Desc
   */
  is_desc?: boolean
}

/**
 * CityOut
 */
export type CityOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  country?: CountryOut | null
}

/**
 * CityOutInfo
 */
export type CityOutInfo = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
  country?: CountryOutInfo | null
}

/**
 * CoinsAddIn
 */
export type CoinsAddIn = {
  /**
   * User Ids
   */
  user_ids: Array<string>
  /**
   * Amount
   */
  amount?: number
  assert_type: AssertEnum
  /**
   * Comment
   */
  comment: string
  comment_type: AdminAddCommentTypeEnum
  /**
   * Task Link
   */
  task_link?: string | null
}

/**
 * CoinsDebitIn
 */
export type CoinsDebitIn = {
  /**
   * User Ids
   */
  user_ids: Array<string>
  amount: PositiveConstraintInt
  assert_type: AssertEnum
  /**
   * Comment
   */
  comment: string
  comment_type: AdminDebitCommentTypeEnum
  /**
   * Task Link
   */
  task_link?: string | null
}

/**
 * CoinsImportError
 */
export type CoinsImportError = {
  /**
   * Row
   */
  row: number
  /**
   * Email
   */
  email: string
  error_type: ImportCoinsErrorEnum
  /**
   * Error Details
   */
  error_details?: Array<unknown> | null
}

/**
 * CoinsImportResult
 */
export type CoinsImportResult = {
  /**
   * Applied
   */
  applied: boolean
  /**
   * Valid Rows
   */
  valid_rows: number
  /**
   * Invalid Rows
   */
  invalid_rows: number
  /**
   * Users Count
   */
  users_count: number
  /**
   * Coins Count
   */
  coins_count: number
  /**
   * Errors
   */
  errors?: Array<CoinsImportError>
}

/**
 * CoinsPerMonth
 */
export type CoinsPerMonth = {
  /**
   * Date
   */
  date: string
  /**
   * Amount
   */
  amount: number
}

/**
 * CoinsPerMonthList
 */
export type CoinsPerMonthList = {
  /**
   * Coins
   */
  coins: Array<CoinsPerMonth>
}

/**
 * CoinsPerUser
 */
export type CoinsPerUser = {
  /**
   * User Id
   */
  user_id: string
  /**
   * First Name
   */
  first_name: string
  /**
   * Last Name
   */
  last_name: string
  /**
   * Amount
   */
  amount: number
}

/**
 * CoinsPerUserList
 */
export type CoinsPerUserList = {
  /**
   * Coins
   */
  coins: Array<CoinsPerUser>
}

/**
 * CountriesOut
 */
export type CountriesOut = {
  /**
   * Countries
   */
  countries: Array<CountryOut>
}

/**
 * CountriesOutInfo
 */
export type CountriesOutInfo = {
  /**
   * Countries
   */
  countries: Array<CountryOutInfo>
}

/**
 * CountryInCreate
 */
export type CountryInCreate = {
  /**
   * Name
   */
  name: string
}

/**
 * CountryInUpdate
 */
export type CountryInUpdate = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
}

/**
 * CountryInfoRequest
 */
export type CountryInfoRequest = {
  filter: FilterIds
  /**
   * Is Desc
   */
  is_desc?: boolean
}

/**
 * CountryOut
 */
export type CountryOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
}

/**
 * CountryOutInfo
 */
export type CountryOutInfo = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
}

/**
 * CurrentUsableCount
 */
export type CurrentUsableCount = {
  /**
   * Count
   */
  count: number
}

/**
 * DBCommentTypeEnum
 */
export const DbCommentTypeEnum = {
  APPRECIATION: 'APPRECIATION',
  CONGRATULATIONS: 'CONGRATULATIONS',
  HIGH_QUALITY_WORK: 'HIGH_QUALITY_WORK',
  MENTORSHIP: 'MENTORSHIP',
  REWARD: 'REWARD',
  CORRECTION: 'CORRECTION',
  ENCOURAGEMENT: 'ENCOURAGEMENT',
} as const

/**
 * DBCommentTypeEnum
 */
export type DbCommentTypeEnum = (typeof DbCommentTypeEnum)[keyof typeof DbCommentTypeEnum]

/**
 * DateFull
 */
export type DateFull = {
  /**
   * Day
   */
  day: number
  /**
   * Month
   */
  month: number
  /**
   * Year
   */
  year: number
}

/**
 * DeliveryAddressIn
 */
export type DeliveryAddressIn = {
  /**
   * Country
   */
  country: string | null
  /**
   * City
   */
  city: string | null
  /**
   * Address
   */
  address: string | null
  /**
   * Postal Code
   */
  postal_code: string | null
  /**
   * Phone
   */
  phone: string | null
  /**
   * Email
   */
  email: string | null
}

/**
 * DeliveryAddressOut
 */
export type DeliveryAddressOut = {
  /**
   * Country
   */
  country: string | null
  /**
   * City
   */
  city: string | null
  /**
   * Address
   */
  address: string | null
  /**
   * Postal Code
   */
  postal_code: string | null
  /**
   * Phone
   */
  phone: string | null
  /**
   * Email
   */
  email: string | null
  /**
   * User Id
   */
  user_id: string
}

/**
 * DepartmentBaseOut
 */
export type DepartmentBaseOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  /**
   * Officeid
   */
  officeId: string | null
  /**
   * Headid
   */
  headId: string | null
  /**
   * Pathids
   */
  pathIds: Array<string>
}

/**
 * DepartmentFilter
 */
export type DepartmentFilter = {
  /**
   * Show Unassigned
   *
   * If set to true, will show users without department - ids param will be ignored
   */
  show_unassigned?: boolean | null
  /**
   * Ids
   *
   * List of department ids
   */
  ids?: Array<string> | null
}

/**
 * DepartmentInCreate
 */
export type DepartmentInCreate = {
  /**
   * Name
   */
  name: string
  /**
   * Parentid
   */
  parentId?: string | null
  /**
   * Headid
   */
  headId?: string | null
  /**
   * Officeid
   */
  officeId?: string | null
}

/**
 * DepartmentInUpdate
 */
export type DepartmentInUpdate = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  /**
   * Parentid
   */
  parentId?: string | null
  /**
   * Headid
   */
  headId?: string | null
  /**
   * Officeid
   */
  officeId?: string | null
}

/**
 * DepartmentNode
 */
export type DepartmentNode = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
  /**
   * Children
   */
  children?: Array<DepartmentNode>
}

/**
 * DepartmentOut
 */
export type DepartmentOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  /**
   * Officeid
   */
  officeId: string | null
  /**
   * Headid
   */
  headId: string | null
  /**
   * Pathids
   */
  pathIds: Array<string>
  /**
   * Haschildren
   */
  hasChildren: boolean
  /**
   * Userscount
   */
  usersCount: number
}

/**
 * DepartmentsBaseOut
 */
export type DepartmentsBaseOut = {
  /**
   * Departments
   */
  departments: Array<DepartmentBaseOut>
}

/**
 * DepartmentsOut
 */
export type DepartmentsOut = {
  /**
   * Departments
   */
  departments: Array<DepartmentOut>
}

/**
 * DepartmentsTreeOut
 */
export type DepartmentsTreeOut = {
  /**
   * Departments
   */
  departments: Array<DepartmentNode>
}

/**
 * EventInCreate
 */
export type EventInCreate = {
  /**
   * Locations
   */
  locations: Array<LocationInOut>
  /**
   * Content
   */
  content: string
  /**
   * Plain Content
   */
  plain_content?: string
  /**
   * Title
   */
  title: string
  /**
   * Event Datetime
   */
  event_datetime: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Normalized Text
   */
  normalized_text?: string
}

/**
 * EventInUpdate
 */
export type EventInUpdate = {
  /**
   * Content
   */
  content: string
  /**
   * Plain Content
   */
  plain_content?: string
  /**
   * Title
   */
  title: string
  /**
   * Event Datetime
   */
  event_datetime: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Normalized Text
   */
  normalized_text?: string
}

/**
 * EventOut
 */
export type EventOut = {
  /**
   * Id
   */
  id: number
  /**
   * Author Id
   */
  author_id: string
  /**
   * Event Datetime
   */
  event_datetime: string
  /**
   * Updated At
   */
  updated_at: string
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Locations
   */
  locations?: Array<LocationInOut>
  /**
   * Is Happened
   */
  readonly is_happened: boolean
}

/**
 * EventsOut
 */
export type EventsOut = {
  /**
   * Events
   */
  events: Array<EventOut>
}

/**
 * ExportFormatEnum
 */
export const ExportFormatEnum = { CSV: 'csv', XLSX: 'xlsx' } as const

/**
 * ExportFormatEnum
 */
export type ExportFormatEnum = (typeof ExportFormatEnum)[keyof typeof ExportFormatEnum]

/**
 * FeedbackCategoriesOut
 */
export type FeedbackCategoriesOut = {
  /**
   * Feedback Categories
   */
  feedback_categories: Array<FeedbackCategoryOut>
}

/**
 * FeedbackCategoryIn
 */
export type FeedbackCategoryIn = {
  /**
   * Name
   */
  name: string
}

/**
 * FeedbackCategoryOut
 */
export type FeedbackCategoryOut = {
  /**
   * Name
   */
  name: string
  /**
   * Id
   */
  id: number
}

/**
 * FeedbackEmailsInOut
 */
export type FeedbackEmailsInOut = {
  /**
   * Emails
   */
  emails: Array<string>
}

/**
 * FileTypeEnum
 */
export const FileTypeEnum = {
  MEDIA_UNKNOWN: 'MEDIA_UNKNOWN',
  MEDIA_USER_AVATAR: 'MEDIA_USER_AVATAR',
  MEDIA_PRODUCT_IMAGE: 'MEDIA_PRODUCT_IMAGE',
  MEDIA_POST_IMAGE: 'MEDIA_POST_IMAGE',
  MEDIA_EVENT_IMAGE: 'MEDIA_EVENT_IMAGE',
  MEDIA_BRANDING_IMAGE: 'MEDIA_BRANDING_IMAGE',
} as const

/**
 * FileTypeEnum
 */
export type FileTypeEnum = (typeof FileTypeEnum)[keyof typeof FileTypeEnum]

/**
 * FilterIds
 */
export type FilterIds = {
  /**
   * Ids
   */
  ids?: Array<string>
}

/**
 * FilterUsers
 */
export type FilterUsers = {
  /**
   * Ids
   */
  ids?: Array<string> | null
  /**
   * Query
   */
  query?: string | null
  /**
   * Is Blocked
   */
  is_blocked?: boolean | null
  department_filter?: DepartmentFilter | null
}

/**
 * FilterUsersRole
 */
export type FilterUsersRole = {
  /**
   * Ids
   */
  ids?: Array<string> | null
  /**
   * Query
   */
  query?: string | null
  /**
   * Is Blocked
   */
  is_blocked?: boolean | null
  department_filter?: DepartmentFilter | null
  role?: RoleEnum | null
}

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
  /**
   * Detail
   */
  detail?: Array<ValidationError>
}

/**
 * IdRequest
 */
export type IdRequest = {
  /**
   * Id
   */
  id: string
}

/**
 * IdVersionRequest
 */
export type IdVersionRequest = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
}

/**
 * ImportCoinsErrorEnum
 */
export const ImportCoinsErrorEnum = {
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  UNSUPPORTED_FILE_TYPE: 'UNSUPPORTED_FILE_TYPE',
  EMPTY_FILE: 'EMPTY_FILE',
  MISSING_COLUMNS: 'MISSING_COLUMNS',
  INVALID_CATEGORY: 'INVALID_CATEGORY',
  INVALID_COINS_VALUE: 'INVALID_COINS_VALUE',
  COINS_OUT_OF_RANGE: 'COINS_OUT_OF_RANGE',
  COMMENT_REQUIRED: 'COMMENT_REQUIRED',
  COMMENT_TOO_LONG: 'COMMENT_TOO_LONG',
  DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_BLOCKED: 'USER_BLOCKED',
  EMAIL_EMPTY: 'EMAIL_EMPTY',
  INVALID_EMAIL: 'INVALID_EMAIL',
  FIRST_NAME_EMPTY: 'FIRST_NAME_EMPTY',
  LAST_NAME_EMPTY: 'LAST_NAME_EMPTY',
} as const

/**
 * ImportCoinsErrorEnum
 */
export type ImportCoinsErrorEnum = (typeof ImportCoinsErrorEnum)[keyof typeof ImportCoinsErrorEnum]

/**
 * JournalListOut
 */
export type JournalListOut = {
  /**
   * Items
   */
  items: Array<JournalRecordOut>
  /**
   * Total
   */
  total: number
}

/**
 * JournalRecordOut
 */
export type JournalRecordOut = {
  /**
   * Id
   */
  id: number
  /**
   * Datetime
   */
  datetime: string
  /**
   * User
   */
  user: string | null
  transaction_type: TransactionTypeEnum
  /**
   * Amount
   */
  amount: number
  coin_type?: AssertEnum | null
  /**
   * Related Object
   */
  related_object?: string | null
  /**
   * Comment
   */
  comment?: string | null
  order_status?: OrderStateEnum | null
  /**
   * Linked Order Id
   */
  linked_order_id?: number | null
}

/**
 * JournalSortByEnum
 */
export const JournalSortByEnum = {
  DATETIME: 'datetime',
  AMOUNT: 'amount',
  TYPE: 'type',
} as const

/**
 * JournalSortByEnum
 */
export type JournalSortByEnum = (typeof JournalSortByEnum)[keyof typeof JournalSortByEnum]

/**
 * ListChildDepartmentsRequest
 */
export type ListChildDepartmentsRequest = {
  /**
   * Parentid
   */
  parentId?: string | null
}

/**
 * ListDepartmentsFilter
 */
export type ListDepartmentsFilter = {
  /**
   * Departmentids
   */
  departmentIds?: Array<string> | null
  /**
   * Query
   */
  query?: string | null
  /**
   * Excludedepartmentid
   */
  excludeDepartmentId?: string | null
}

/**
 * ListDepartmentsRequest
 */
export type ListDepartmentsRequest = {
  filter: ListDepartmentsFilter
  /**
   * Is Desc
   */
  is_desc?: boolean
}

/**
 * ListUserProfilesFullPageRequest
 */
export type ListUserProfilesFullPageRequest = {
  filter: FilterUsersRole
  page: PageIn
  /**
   * Is Desc
   */
  is_desc?: boolean
}

/**
 * ListUserProfilesPageRequest
 */
export type ListUserProfilesPageRequest = {
  filter: FilterUsers
  page: PageIn
}

/**
 * LocationInOut
 */
export type LocationInOut = {
  /**
   * Id
   */
  id?: string | null
  /**
   * Name
   */
  name?: string | null
  type: LocationTypeEnum
  /**
   * Include
   */
  include?: boolean
}

/**
 * LocationTypeEnum
 */
export const LocationTypeEnum = {
  ALL: 'ALL',
  CITY: 'CITY',
  COUNTRY: 'COUNTRY',
  OFFICE: 'OFFICE',
} as const

/**
 * LocationTypeEnum
 */
export type LocationTypeEnum = (typeof LocationTypeEnum)[keyof typeof LocationTypeEnum]

export type NotNegativeConstraintInt = number

/**
 * OfficeInCreate
 */
export type OfficeInCreate = {
  /**
   * Cityid
   */
  cityId: string
  /**
   * Name
   */
  name: string
  /**
   * Address
   */
  address: string
  /**
   * Officemanagerid
   */
  officeManagerId?: string | null
}

/**
 * OfficeInUpdate
 */
export type OfficeInUpdate = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Cityid
   */
  cityId: string
  /**
   * Name
   */
  name: string
  /**
   * Address
   */
  address: string
  /**
   * Officemanagerid
   */
  officeManagerId?: string | null
}

/**
 * OfficeInfoFilter
 */
export type OfficeInfoFilter = {
  /**
   * Ids
   */
  ids?: Array<string>
  /**
   * Query
   */
  query?: string | null
  /**
   * Cityid
   */
  cityId?: string | null
  /**
   * Countryid
   */
  countryId?: string | null
}

/**
 * OfficeInfoRequest
 */
export type OfficeInfoRequest = {
  filter: OfficeInfoFilter
  /**
   * Is Desc
   */
  is_desc?: boolean
}

/**
 * OfficeOut
 */
export type OfficeOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  city?: CityOut | null
  /**
   * Name
   */
  name: string
  /**
   * Address
   */
  address: string
  /**
   * Office Manager Id
   */
  office_manager_id?: string | null
}

/**
 * OfficeOutInfo
 */
export type OfficeOutInfo = {
  /**
   * Id
   */
  id: string
  city?: CityOutInfo | null
  /**
   * Name
   */
  name: string
  /**
   * Address
   */
  address: string
  /**
   * Office Manager Id
   */
  office_manager_id?: string | null
}

/**
 * OfficesOut
 */
export type OfficesOut = {
  /**
   * Offices
   */
  offices: Array<OfficeOut>
}

/**
 * OfficesOutInfo
 */
export type OfficesOutInfo = {
  /**
   * Offices
   */
  offices: Array<OfficeOutInfo>
}

/**
 * OrderDirectionEnum
 */
export const OrderDirectionEnum = { ASC: 'asc', DESC: 'desc' } as const

/**
 * OrderDirectionEnum
 */
export type OrderDirectionEnum = (typeof OrderDirectionEnum)[keyof typeof OrderDirectionEnum]

/**
 * OrderIn
 */
export type OrderIn = {
  /**
   * Order Products
   */
  order_products: Array<OrderProductIn>
  /**
   * Country
   */
  country: string
  /**
   * City
   */
  city: string
  /**
   * Address
   */
  address: string
  /**
   * Postal Code
   */
  postal_code: string
  /**
   * Phone
   */
  phone: string
  /**
   * Email
   */
  email: string
}

/**
 * OrderOut
 */
export type OrderOut = {
  /**
   * Id
   */
  id: number
  /**
   * Order Number
   */
  order_number: string
  /**
   * User Id
   */
  user_id?: string | null
  /**
   * Created At
   */
  created_at: string
  status: OrderStateEnum
  /**
   * Track Code
   */
  track_code?: string | null
  /**
   * Delivery Service Url
   */
  delivery_service_url?: string | null
  /**
   * Full Name
   */
  full_name: string
  /**
   * Country
   */
  country: string
  /**
   * City
   */
  city: string
  /**
   * Address
   */
  address: string
  /**
   * Postal Code
   */
  postal_code: string
  /**
   * Phone
   */
  phone: string
  /**
   * Email
   */
  email: string
  /**
   * Can Be Cancelled Until
   */
  can_be_cancelled_until: string | null
  /**
   * Order Products
   */
  order_products: Array<OrderProductOut>
}

/**
 * OrderProductIn
 */
export type OrderProductIn = {
  /**
   * Product Id
   */
  product_id: number
  /**
   * Product Sku Id
   */
  product_sku_id: number
  quantity: PositiveConstraintInt
}

/**
 * OrderProductOut
 */
export type OrderProductOut = {
  /**
   * Id
   */
  id: number
  /**
   * Product Id
   */
  product_id: number
  /**
   * Product Name
   */
  product_name: string
  /**
   * Product Sku Id
   */
  product_sku_id: number
  /**
   * Product Attributes
   */
  product_attributes: Array<ProductAttributeValue>
  /**
   * Price
   */
  price: number
  /**
   * Quantity
   */
  quantity: number
  /**
   * Attachments
   */
  attachments: Array<string>
  /**
   * Attribute 1
   */
  attribute_1?: string | null
  /**
   * Attribute 2
   */
  attribute_2?: string | null
  /**
   * Tag
   */
  tag?: string | null
}

/**
 * OrderStateEnum
 */
export const OrderStateEnum = {
  WAITS_FOR_CONFIRMATION: 'WAITS_FOR_CONFIRMATION',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  SHIPPED: 'SHIPPED',
  COMPLETED: 'COMPLETED',
} as const

/**
 * OrderStateEnum
 */
export type OrderStateEnum = (typeof OrderStateEnum)[keyof typeof OrderStateEnum]

/**
 * OrderStateIn
 */
export type OrderStateIn = {
  state: OrderStateEnum
}

/**
 * OrderStateOut
 */
export type OrderStateOut = {
  state: OrderStateEnum
  /**
   * Datetime
   */
  datetime: string
}

/**
 * OrderStatesOut
 */
export type OrderStatesOut = {
  /**
   * States
   */
  states: Array<OrderStateOut>
}

/**
 * OrdersOut
 */
export type OrdersOut = {
  /**
   * Orders
   */
  orders: Array<OrderOut>
}

/**
 * PageIn
 */
export type PageIn = {
  number: PositiveConstrainIntQuery
  size: PositiveConstrainIntQuery
}

/**
 * PaginationOut
 */
export type PaginationOut = {
  /**
   * Pagenumber
   */
  pageNumber: number
  /**
   * Pagesize
   */
  pageSize: number
  /**
   * Totalitems
   */
  totalItems: number
  /**
   * Totalpages
   */
  totalPages: number
}

/**
 * PortalConfigOut
 */
export type PortalConfigOut = {
  /**
   * Cancellation Shop Order Period Days
   */
  cancellation_shop_order_period_days: number
  /**
   * Employee Probation Period Months
   */
  employee_probation_period_months: number
}

/**
 * PositionCreateIn
 */
export type PositionCreateIn = {
  /**
   * Name
   */
  name: string
}

/**
 * PositionOut
 */
export type PositionOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Name
   */
  name: string
  /**
   * Userscount
   */
  usersCount: number
}

/**
 * PositionUpdateIn
 */
export type PositionUpdateIn = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
  /**
   * Version
   */
  version: number
}

/**
 * PositionsFilter
 */
export type PositionsFilter = {
  /**
   * Query
   */
  query?: string | null
}

/**
 * PositionsOut
 */
export type PositionsOut = {
  /**
   * Positions
   */
  positions: Array<PositionOut>
}

/**
 * PositionsRequest
 */
export type PositionsRequest = {
  filter: PositionsFilter
  /**
   * Is Desc
   */
  is_desc?: boolean
}

export type PositiveConstrainIntQuery = number

export type PositiveConstraintInt = number

/**
 * PostIn
 */
export type PostIn = {
  /**
   * Content
   */
  content: string
  /**
   * Plain Content
   */
  plain_content?: string
  /**
   * Title
   */
  title: string
  /**
   * Published At
   */
  published_at: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Normalized Text
   */
  normalized_text?: string
}

/**
 * PostOut
 */
export type PostOut = {
  /**
   * Id
   */
  id: number
  /**
   * Author Id
   */
  author_id: string
  /**
   * Published At
   */
  published_at: string
  /**
   * Updated At
   */
  updated_at: string
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Likes Count
   */
  likes_count: number
  /**
   * Is Liked
   */
  is_liked?: boolean
  /**
   * Is Published
   */
  readonly is_published: boolean
}

/**
 * PostsOut
 */
export type PostsOut = {
  /**
   * Posts
   */
  posts: Array<PostOut>
}

/**
 * ProductAttributeValue
 */
export type ProductAttributeValue = {
  /**
   * Name
   */
  name: string
  /**
   * Value
   */
  value: string
}

/**
 * ProductIn
 */
export type ProductIn = {
  /**
   * Locations
   */
  locations: Array<LocationInOut>
  /**
   * Content
   */
  content: string
  /**
   * Plain Content
   */
  plain_content?: string
  /**
   * Name
   */
  name: string
  /**
   * Attributes
   */
  attributes?: Array<AttributeGroupIn>
  price: PositiveConstraintInt
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Tag Ids
   */
  tag_ids?: Array<number>
  /**
   * Label Id
   */
  label_id?: number | null
  /**
   * Is Deleted
   */
  is_deleted?: boolean | null
}

/**
 * ProductLabelBriefOut
 */
export type ProductLabelBriefOut = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
}

/**
 * ProductLabelIn
 */
export type ProductLabelIn = {
  /**
   * Name
   */
  name: string
}

/**
 * ProductLabelOut
 */
export type ProductLabelOut = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
  /**
   * Is Active
   */
  is_active: boolean
}

/**
 * ProductLabelUpdateIn
 */
export type ProductLabelUpdateIn = {
  /**
   * Name
   */
  name: string
  /**
   * Is Active
   */
  is_active?: boolean | null
}

/**
 * ProductLabelsOut
 */
export type ProductLabelsOut = {
  /**
   * Labels
   */
  labels: Array<ProductLabelOut>
}

/**
 * ProductOut
 */
export type ProductOut = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
  /**
   * Price
   */
  price: number
  /**
   * Buy Counter
   */
  buy_counter: number
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Tag Ids
   */
  tag_ids: Array<number>
  label?: ProductLabelBriefOut | null
  /**
   * Is Deleted
   */
  is_deleted?: boolean | null
  /**
   * Can Be Ordered
   */
  can_be_ordered?: boolean | null
  /**
   * Average Rating
   */
  average_rating?: number | null
  /**
   * Reviews Count
   */
  reviews_count?: number
  /**
   * Stock Count
   */
  stock_count: number
}

/**
 * ProductOutFull
 */
export type ProductOutFull = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
  /**
   * Price
   */
  price: number
  /**
   * Buy Counter
   */
  buy_counter: number
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Tag Ids
   */
  tag_ids: Array<number>
  label?: ProductLabelBriefOut | null
  /**
   * Is Deleted
   */
  is_deleted?: boolean | null
  /**
   * Can Be Ordered
   */
  can_be_ordered?: boolean | null
  /**
   * Average Rating
   */
  average_rating?: number | null
  /**
   * Reviews Count
   */
  reviews_count?: number
  /**
   * Content
   */
  content: string
  /**
   * Attributes
   */
  attributes: Array<AttributeGroupOut>
  /**
   * Stock
   */
  stock: Array<ProductSkuOut>
  /**
   * Locations
   */
  locations?: Array<LocationInOut>
}

/**
 * ProductReviewAdminOut
 */
export type ProductReviewAdminOut = {
  /**
   * Id
   */
  id: number
  /**
   * Order Id
   */
  order_id: number
  /**
   * Product Id
   */
  product_id: number
  /**
   * Rating
   */
  rating: number
  /**
   * Comment
   */
  comment: string | null
  status: ProductReviewStatusEnum
  /**
   * Created At
   */
  created_at: string
  /**
   * Published At
   */
  published_at: string | null
  author: ProductReviewAuthorOut
  /**
   * User Id
   */
  user_id: string
  /**
   * Product Name
   */
  product_name: string
}

/**
 * ProductReviewAuthorOut
 */
export type ProductReviewAuthorOut = {
  /**
   * Firstname
   */
  firstname: string
  /**
   * Lastname
   */
  lastname: string
}

/**
 * ProductReviewIn
 */
export type ProductReviewIn = {
  /**
   * Rating
   */
  rating: number
  /**
   * Comment
   */
  comment?: string | null
}

/**
 * ProductReviewOut
 */
export type ProductReviewOut = {
  /**
   * Id
   */
  id: number
  /**
   * Order Id
   */
  order_id: number
  /**
   * Product Id
   */
  product_id: number
  /**
   * Rating
   */
  rating: number
  /**
   * Comment
   */
  comment: string | null
  status: ProductReviewStatusEnum
  /**
   * Created At
   */
  created_at: string
  /**
   * Published At
   */
  published_at: string | null
  author: ProductReviewAuthorOut
}

/**
 * ProductReviewStatusEnum
 */
export const ProductReviewStatusEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const

/**
 * ProductReviewStatusEnum
 */
export type ProductReviewStatusEnum = (typeof ProductReviewStatusEnum)[keyof typeof ProductReviewStatusEnum]

/**
 * ProductSKUIn
 */
export type ProductSkuIn = {
  /**
   * Id
   */
  id: number
  quantity: NotNegativeConstraintInt
}

/**
 * ProductSKUOut
 */
export type ProductSkuOut = {
  /**
   * Id
   */
  id: number
  /**
   * Attribute 1 Id
   */
  attribute_1_id: number | null
  /**
   * Value 1 Id
   */
  value_1_id: number | null
  /**
   * Attribute 2 Id
   */
  attribute_2_id: number | null
  /**
   * Value 2 Id
   */
  value_2_id: number | null
  quantity: NotNegativeConstraintInt
}

/**
 * ProductStockIn
 */
export type ProductStockIn = {
  /**
   * Stock
   */
  stock: Array<ProductSkuIn>
}

/**
 * ProductStockOut
 */
export type ProductStockOut = {
  /**
   * Stock
   */
  stock: Array<ProductSkuOut>
}

/**
 * ProductTagIn
 */
export type ProductTagIn = {
  /**
   * Name
   */
  name: string
}

/**
 * ProductTagOut
 */
export type ProductTagOut = {
  /**
   * Id
   */
  id: number
  /**
   * Name
   */
  name: string
  /**
   * Product Count
   */
  product_count: number
}

/**
 * ProductTagsOut
 */
export type ProductTagsOut = {
  /**
   * Tags
   */
  tags: Array<ProductTagOut>
}

/**
 * ProductValueIn
 */
export type ProductValueIn = {
  /**
   * Id
   */
  id?: number | null
  /**
   * Value
   */
  value?: string | null
}

/**
 * ProductValueOut
 *
 * {"id": 13, "value": "White"}
 */
export type ProductValueOut = {
  /**
   * Id
   */
  id: number
  /**
   * Value
   */
  value: string
}

/**
 * ProductsOut
 */
export type ProductsOut = {
  /**
   * Products
   */
  products: Array<ProductOut>
}

/**
 * QuestionIn
 */
export type QuestionIn = {
  /**
   * Locations
   */
  locations: Array<LocationInOut>
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
}

/**
 * QuestionOut
 */
export type QuestionOut = {
  /**
   * Id
   */
  id: number
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
  /**
   * Locations
   */
  locations?: Array<LocationInOut>
}

/**
 * QuestionsOut
 */
export type QuestionsOut = {
  /**
   * Questions
   */
  questions: Array<QuestionOut>
}

/**
 * RoleEnum
 */
export const RoleEnum = {
  ADMIN: 'ADMIN',
  CONTENT_MANAGER: 'CONTENT_MANAGER',
  EMPLOYEE: 'EMPLOYEE',
  SHOP_MANAGER: 'SHOP_MANAGER',
} as const

/**
 * RoleEnum
 */
export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum]

/**
 * SetOrderTrackCodeIn
 */
export type SetOrderTrackCodeIn = {
  /**
   * Track Code
   */
  track_code: string
  /**
   * Delivery Service Url
   *
   * Service for tracking the order
   */
  delivery_service_url: string
}

/**
 * SortByEnum
 */
export const SortByEnum = {
  NAME: 'name',
  POPULARITY: 'popularity',
  PRICE: 'price',
} as const

/**
 * SortByEnum
 */
export type SortByEnum = (typeof SortByEnum)[keyof typeof SortByEnum]

export type StrictQuery = string | null

/**
 * TenantBonusesConfigsOut
 */
export type TenantBonusesConfigsOut = {
  /**
   * Configs
   */
  configs: Array<TenantBonusesRowOut>
}

/**
 * TenantBonusesRowOut
 */
export type TenantBonusesRowOut = {
  bonus_name: BonusNameEnum
  /**
   * Is Enabled
   */
  is_enabled: boolean
  amount: NotNegativeConstraintInt
  /**
   * Message
   */
  message: string
}

/**
 * TenantServicesConfigOut
 */
export type TenantServicesConfigOut = {
  /**
   * Is Reddy Enabled
   */
  is_reddy_enabled: boolean
  /**
   * Is Email Enabled
   */
  is_email_enabled: boolean
  /**
   * Is Analytics Enabled
   */
  is_analytics_enabled: boolean
}

/**
 * TransactionTypeEnum
 */
export const TransactionTypeEnum = {
  BILLING_PERIOD_CHANGE: 'BILLING_PERIOD_CHANGE',
  DEPOSIT: 'DEPOSIT',
  PURCHASE: 'PURCHASE',
  REFUND: 'REFUND',
  TRANSFER: 'TRANSFER',
  ADMIN_CREDIT: 'ADMIN_CREDIT',
  ADMIN_DEBIT: 'ADMIN_DEBIT',
} as const

/**
 * TransactionTypeEnum
 */
export type TransactionTypeEnum = (typeof TransactionTypeEnum)[keyof typeof TransactionTypeEnum]

/**
 * TransferIn
 */
export type TransferIn = {
  /**
   * User Id
   */
  user_id: string
  amount: PositiveConstraintInt
  /**
   * Comment
   */
  comment?: string | null
  comment_type: UserTransferCommentTypeEnum
}

/**
 * TransferStatsPerMonth
 */
export type TransferStatsPerMonth = {
  /**
   * Date
   */
  date: string
  /**
   * Transfer Count
   */
  transfer_count: number
  /**
   * Avg Amount
   */
  avg_amount: number
}

/**
 * TransferStatsPerMonthList
 */
export type TransferStatsPerMonthList = {
  /**
   * Data
   */
  data: Array<TransferStatsPerMonth>
}

/**
 * UpdatePortalConfigIn
 */
export type UpdatePortalConfigIn = {
  /**
   * Cancellation Shop Order Period Days
   */
  cancellation_shop_order_period_days: number
  /**
   * Employee Probation Period Months
   */
  employee_probation_period_months: number
}

/**
 * UpdateTenantBonusesRowIn
 */
export type UpdateTenantBonusesRowIn = {
  bonus_name: BonusNameEnum
  /**
   * Is Enabled
   */
  is_enabled: boolean
  amount: NotNegativeConstraintInt
  /**
   * Message
   */
  message: string
}

/**
 * UpdateTenantServicesRowIn
 */
export type UpdateTenantServicesRowIn = {
  /**
   * Is Reddy Enabled
   */
  is_reddy_enabled: boolean
  /**
   * Is Email Enabled
   */
  is_email_enabled: boolean
  /**
   * Is Analytics Enabled
   */
  is_analytics_enabled: boolean
}

/**
 * UploadImageResponse
 */
export type UploadImageResponse = {
  /**
   * Media Id
   */
  media_id: string
}

/**
 * UserEngagementPerMonth
 */
export type UserEngagementPerMonth = {
  /**
   * Date
   */
  date: string
  /**
   * User Count
   */
  user_count: number
}

/**
 * UserEngagementPerMonthList
 */
export type UserEngagementPerMonthList = {
  /**
   * Data
   */
  data: Array<UserEngagementPerMonth>
}

/**
 * UserIn
 */
export type UserIn = {
  role: RoleEnum
}

/**
 * UserInBlock
 */
export type UserInBlock = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
}

/**
 * UserInCreate
 */
export type UserInCreate = {
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  role?: RoleEnum
  birthday?: DateFull | null
  contacts?: UserProfileContacts | null
  /**
   * Positionid
   */
  positionId?: string | null
  /**
   * Officeid
   */
  officeId?: string | null
  /**
   * Departmentid
   */
  departmentId?: string | null
  joinDate?: DateFull | null
  /**
   * Note
   */
  note?: string | null
  /**
   * Isprobationpassed
   */
  isProbationPassed?: boolean
}

/**
 * UserInUnblock
 */
export type UserInUnblock = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
}

/**
 * UserInUpdate
 */
export type UserInUpdate = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  birthday?: DateFull | null
  contacts?: UserProfileContacts | null
  /**
   * Positionid
   */
  positionId?: string | null
  /**
   * Officeid
   */
  officeId?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Departmentid
   */
  departmentId?: string | null
  joinDate?: DateFull | null
  /**
   * Note
   */
  note?: string | null
  /**
   * Isprobationpassed
   */
  isProbationPassed: boolean
}

/**
 * UserNearBirthdayOut
 */
export type UserNearBirthdayOut = {
  /**
   * Id
   */
  id: string
  /**
   * Email
   */
  email: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Join Date
   */
  join_date?: string | null
}

/**
 * UserOutFull
 */
export type UserOutFull = {
  /**
   * Id
   */
  id: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Office Id
   */
  office_id?: string | null
  birthday?: Birthday | null
  role: RoleEnum
}

/**
 * UserProfileBaseOut
 */
export type UserProfileBaseOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  readonly contacts: UserProfileContacts
  /**
   * Isprobationpassed
   */
  readonly isProbationPassed: boolean
}

/**
 * UserProfileContacts
 */
export type UserProfileContacts = {
  /**
   * Reddy
   */
  reddy?: number | null
  /**
   * Telegram
   */
  telegram?: string | null
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Additionalphone
   */
  additionalPhone?: string | null
}

/**
 * UserProfileOut
 */
export type UserProfileOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  office?: OfficeOutInfo | null
  department?: DepartmentBaseOut | null
  head?: UserProfileBaseOut | null
  readonly contacts: UserProfileContacts
  /**
   * Isprobationpassed
   */
  readonly isProbationPassed: boolean
}

/**
 * UserProfileRoleOut
 */
export type UserProfileRoleOut = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  office?: OfficeOutInfo | null
  department?: DepartmentBaseOut | null
  head?: UserProfileBaseOut | null
  role: RoleEnum
  readonly contacts: UserProfileContacts
  /**
   * Isprobationpassed
   */
  readonly isProbationPassed: boolean
}

/**
 * UserProfilesFullPageOut
 */
export type UserProfilesFullPageOut = {
  /**
   * Userprofiles
   */
  userProfiles: Array<UserProfileRoleOut>
  pagination: PaginationOut
}

/**
 * UserProfilesPageOut
 */
export type UserProfilesPageOut = {
  /**
   * Userprofiles
   */
  userProfiles: Array<UserProfileOut>
  pagination: PaginationOut
}

/**
 * UserTransferCommentTypeEnum
 *
 * Using for user actions
 */
export const UserTransferCommentTypeEnum = {
  APPRECIATION: 'APPRECIATION',
  CONGRATULATIONS: 'CONGRATULATIONS',
  HIGH_QUALITY_WORK: 'HIGH_QUALITY_WORK',
  MENTORSHIP: 'MENTORSHIP',
} as const

/**
 * UserTransferCommentTypeEnum
 *
 * Using for user actions
 */
export type UserTransferCommentTypeEnum = (typeof UserTransferCommentTypeEnum)[keyof typeof UserTransferCommentTypeEnum]

/**
 * UsersNearBirthdayOut
 */
export type UsersNearBirthdayOut = {
  /**
   * Users
   */
  users: Array<UserNearBirthdayOut>
}

/**
 * ValidationError
 */
export type ValidationError = {
  /**
   * Location
   */
  loc: Array<string | number>
  /**
   * Message
   */
  msg: string
  /**
   * Error Type
   */
  type: string
  /**
   * Input
   */
  input?: unknown
  /**
   * Context
   */
  ctx?: {
    [key: string]: unknown
  }
}

/**
 * EventOut
 */
export type EventOutWritable = {
  /**
   * Id
   */
  id: number
  /**
   * Author Id
   */
  author_id: string
  /**
   * Event Datetime
   */
  event_datetime: string
  /**
   * Updated At
   */
  updated_at: string
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Locations
   */
  locations?: Array<LocationInOut>
}

/**
 * EventsOut
 */
export type EventsOutWritable = {
  /**
   * Events
   */
  events: Array<EventOutWritable>
}

/**
 * PostOut
 */
export type PostOutWritable = {
  /**
   * Id
   */
  id: number
  /**
   * Author Id
   */
  author_id: string
  /**
   * Published At
   */
  published_at: string
  /**
   * Updated At
   */
  updated_at: string
  /**
   * Title
   */
  title: string
  /**
   * Content
   */
  content: string
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Likes Count
   */
  likes_count: number
  /**
   * Is Liked
   */
  is_liked?: boolean
}

/**
 * PostsOut
 */
export type PostsOutWritable = {
  /**
   * Posts
   */
  posts: Array<PostOutWritable>
}

/**
 * UserProfileBaseOut
 */
export type UserProfileBaseOutWritable = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
}

/**
 * UserProfileOut
 */
export type UserProfileOutWritable = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  office?: OfficeOutInfo | null
  department?: DepartmentBaseOut | null
  head?: UserProfileBaseOutWritable | null
}

/**
 * UserProfileRoleOut
 */
export type UserProfileRoleOutWritable = {
  /**
   * Id
   */
  id: string
  /**
   * Version
   */
  version: number
  /**
   * Email
   */
  email: string
  /**
   * Firstname
   */
  firstName: string
  /**
   * Lastname
   */
  lastName: string
  /**
   * Position
   */
  position: string | null
  /**
   * Position Id
   */
  position_id: string | null
  /**
   * Blocked
   */
  blocked: boolean
  /**
   * Attachments
   */
  attachments?: Array<string>
  /**
   * Birthday
   */
  birthday?: string | null
  /**
   * Joindate
   */
  joinDate: string | null
  /**
   * Probation Passed At
   */
  probation_passed_at?: string | null
  /**
   * Created At
   */
  created_at: string
  /**
   * Updated At
   */
  updated_at: string
  office?: OfficeOutInfo | null
  department?: DepartmentBaseOut | null
  head?: UserProfileBaseOutWritable | null
  role: RoleEnum
}

/**
 * UserProfilesFullPageOut
 */
export type UserProfilesFullPageOutWritable = {
  /**
   * Userprofiles
   */
  userProfiles: Array<UserProfileRoleOutWritable>
  pagination: PaginationOut
}

/**
 * UserProfilesPageOut
 */
export type UserProfilesPageOutWritable = {
  /**
   * Userprofiles
   */
  userProfiles: Array<UserProfileOutWritable>
  pagination: PaginationOut
}

export type VersionVersionGetData = {
  body?: never
  path?: never
  query?: never
  url: '/version'
}

export type VersionVersionGetResponses = {
  /**
   * Response Version Version Get
   *
   * Successful Response
   */
  200: {
    [key: string]: string
  }
}

export type VersionVersionGetResponse = VersionVersionGetResponses[keyof VersionVersionGetResponses]

export type GetPostsPostsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Page
     */
    page?: number
    /**
     * Per Page
     */
    per_page?: number
    order?: OrderDirectionEnum
    /**
     * Query
     */
    query?: StrictQuery | null
  }
  url: '/posts'
}

export type GetPostsPostsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetPostsPostsGetError = GetPostsPostsGetErrors[keyof GetPostsPostsGetErrors]

export type GetPostsPostsGetResponses = {
  /**
   * Successful Response
   */
  200: PostsOut
}

export type GetPostsPostsGetResponse = GetPostsPostsGetResponses[keyof GetPostsPostsGetResponses]

export type CreatePostPostsPostData = {
  body: PostIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/posts'
}

export type CreatePostPostsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreatePostPostsPostError = CreatePostPostsPostErrors[keyof CreatePostPostsPostErrors]

export type CreatePostPostsPostResponses = {
  /**
   * Successful Response
   */
  201: PostOut
}

export type CreatePostPostsPostResponse = CreatePostPostsPostResponses[keyof CreatePostPostsPostResponses]

export type DeletePostPostsPostIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Post Id
     */
    post_id: number
  }
  query?: never
  url: '/posts/{post_id}'
}

export type DeletePostPostsPostIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeletePostPostsPostIdDeleteError =
  DeletePostPostsPostIdDeleteErrors[keyof DeletePostPostsPostIdDeleteErrors]

export type DeletePostPostsPostIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeletePostPostsPostIdDeleteResponse =
  DeletePostPostsPostIdDeleteResponses[keyof DeletePostPostsPostIdDeleteResponses]

export type GetPostPostsPostIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Post Id
     */
    post_id: number
  }
  query?: never
  url: '/posts/{post_id}'
}

export type GetPostPostsPostIdGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetPostPostsPostIdGetError = GetPostPostsPostIdGetErrors[keyof GetPostPostsPostIdGetErrors]

export type GetPostPostsPostIdGetResponses = {
  /**
   * Successful Response
   */
  200: PostOut
}

export type GetPostPostsPostIdGetResponse = GetPostPostsPostIdGetResponses[keyof GetPostPostsPostIdGetResponses]

export type UpdatePostPostsPostIdPutData = {
  body: PostIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Post Id
     */
    post_id: number
  }
  query?: never
  url: '/posts/{post_id}'
}

export type UpdatePostPostsPostIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdatePostPostsPostIdPutError = UpdatePostPostsPostIdPutErrors[keyof UpdatePostPostsPostIdPutErrors]

export type UpdatePostPostsPostIdPutResponses = {
  /**
   * Successful Response
   */
  200: PostOut
}

export type UpdatePostPostsPostIdPutResponse =
  UpdatePostPostsPostIdPutResponses[keyof UpdatePostPostsPostIdPutResponses]

export type ToggleLikePostPostsPostIdToggleLikePostData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Post Id
     */
    post_id: number
  }
  query?: never
  url: '/posts/{post_id}/toggle_like'
}

export type ToggleLikePostPostsPostIdToggleLikePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ToggleLikePostPostsPostIdToggleLikePostError =
  ToggleLikePostPostsPostIdToggleLikePostErrors[keyof ToggleLikePostPostsPostIdToggleLikePostErrors]

export type ToggleLikePostPostsPostIdToggleLikePostResponses = {
  /**
   * Successful Response
   */
  200: PostOut
}

export type ToggleLikePostPostsPostIdToggleLikePostResponse =
  ToggleLikePostPostsPostIdToggleLikePostResponses[keyof ToggleLikePostPostsPostIdToggleLikePostResponses]

export type GetQuestionsQuestionsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Return All
     */
    return_all?: boolean
  }
  url: '/questions'
}

export type GetQuestionsQuestionsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetQuestionsQuestionsGetError = GetQuestionsQuestionsGetErrors[keyof GetQuestionsQuestionsGetErrors]

export type GetQuestionsQuestionsGetResponses = {
  /**
   * Successful Response
   */
  200: QuestionsOut
}

export type GetQuestionsQuestionsGetResponse =
  GetQuestionsQuestionsGetResponses[keyof GetQuestionsQuestionsGetResponses]

export type CreateQuestionQuestionsPostData = {
  body: QuestionIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/questions'
}

export type CreateQuestionQuestionsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateQuestionQuestionsPostError =
  CreateQuestionQuestionsPostErrors[keyof CreateQuestionQuestionsPostErrors]

export type CreateQuestionQuestionsPostResponses = {
  /**
   * Successful Response
   */
  201: QuestionOut
}

export type CreateQuestionQuestionsPostResponse =
  CreateQuestionQuestionsPostResponses[keyof CreateQuestionQuestionsPostResponses]

export type DeleteQuestionQuestionsQuestionsIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Questions Id
     */
    questions_id: number
  }
  query?: never
  url: '/questions/{questions_id}'
}

export type DeleteQuestionQuestionsQuestionsIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteQuestionQuestionsQuestionsIdDeleteError =
  DeleteQuestionQuestionsQuestionsIdDeleteErrors[keyof DeleteQuestionQuestionsQuestionsIdDeleteErrors]

export type DeleteQuestionQuestionsQuestionsIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteQuestionQuestionsQuestionsIdDeleteResponse =
  DeleteQuestionQuestionsQuestionsIdDeleteResponses[keyof DeleteQuestionQuestionsQuestionsIdDeleteResponses]

export type UpdateQuestionQuestionsQuestionsIdPutData = {
  body: QuestionIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Questions Id
     */
    questions_id: number
  }
  query?: never
  url: '/questions/{questions_id}'
}

export type UpdateQuestionQuestionsQuestionsIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateQuestionQuestionsQuestionsIdPutError =
  UpdateQuestionQuestionsQuestionsIdPutErrors[keyof UpdateQuestionQuestionsQuestionsIdPutErrors]

export type UpdateQuestionQuestionsQuestionsIdPutResponses = {
  /**
   * Successful Response
   */
  200: QuestionOut
}

export type UpdateQuestionQuestionsQuestionsIdPutResponse =
  UpdateQuestionQuestionsQuestionsIdPutResponses[keyof UpdateQuestionQuestionsQuestionsIdPutResponses]

export type GetUsersNearBirthdaysUsersNearBirthdaysGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Days
     */
    days?: number
  }
  url: '/users/near_birthdays'
}

export type GetUsersNearBirthdaysUsersNearBirthdaysGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUsersNearBirthdaysUsersNearBirthdaysGetError =
  GetUsersNearBirthdaysUsersNearBirthdaysGetErrors[keyof GetUsersNearBirthdaysUsersNearBirthdaysGetErrors]

export type GetUsersNearBirthdaysUsersNearBirthdaysGetResponses = {
  /**
   * Successful Response
   */
  200: UsersNearBirthdayOut
}

export type GetUsersNearBirthdaysUsersNearBirthdaysGetResponse =
  GetUsersNearBirthdaysUsersNearBirthdaysGetResponses[keyof GetUsersNearBirthdaysUsersNearBirthdaysGetResponses]

export type SetUserRoleUsersUserIdRolePutData = {
  body: UserIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * User Id
     */
    user_id: string
  }
  query?: never
  url: '/users/{user_id}/role'
}

export type SetUserRoleUsersUserIdRolePutErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SetUserRoleUsersUserIdRolePutError =
  SetUserRoleUsersUserIdRolePutErrors[keyof SetUserRoleUsersUserIdRolePutErrors]

export type SetUserRoleUsersUserIdRolePutResponses = {
  /**
   * Successful Response
   */
  200: UserOutFull
}

export type SetUserRoleUsersUserIdRolePutResponse =
  SetUserRoleUsersUserIdRolePutResponses[keyof SetUserRoleUsersUserIdRolePutResponses]

export type SetUserAvatarUsersUserIdAvatarPutData = {
  body: AvatarIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * User Id
     */
    user_id: string
  }
  query?: never
  url: '/users/{user_id}/avatar'
}

export type SetUserAvatarUsersUserIdAvatarPutErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SetUserAvatarUsersUserIdAvatarPutError =
  SetUserAvatarUsersUserIdAvatarPutErrors[keyof SetUserAvatarUsersUserIdAvatarPutErrors]

export type SetUserAvatarUsersUserIdAvatarPutResponses = {
  /**
   * Successful Response
   */
  200: UserOutFull
}

export type SetUserAvatarUsersUserIdAvatarPutResponse =
  SetUserAvatarUsersUserIdAvatarPutResponses[keyof SetUserAvatarUsersUserIdAvatarPutResponses]

export type ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostData = {
  body: ListUserProfilesPageRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/ListUserProfilesPage'
}

export type ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostError =
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors[keyof ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors]

export type ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses = {
  /**
   * Successful Response
   */
  200: UserProfilesPageOut
}

export type ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponse =
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses[keyof ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses]

export type ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostData = {
  body: ListUserProfilesFullPageRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/ListUserProfilesFullPage'
}

export type ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostError =
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors[keyof ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors]

export type ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses = {
  /**
   * Successful Response
   */
  200: UserProfilesFullPageOut
}

export type ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponse =
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses[keyof ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses]

export type GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/GetCurrentUser'
}

export type GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostError =
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors[keyof GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors]

export type GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses = {
  /**
   * Successful Response
   */
  200: UserProfileRoleOut
}

export type GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponse =
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses[keyof GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses]

export type GetProductTagsShopProductsTagsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/shop/products/tags'
}

export type GetProductTagsShopProductsTagsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetProductTagsShopProductsTagsGetError =
  GetProductTagsShopProductsTagsGetErrors[keyof GetProductTagsShopProductsTagsGetErrors]

export type GetProductTagsShopProductsTagsGetResponses = {
  /**
   * Successful Response
   */
  200: ProductTagsOut
}

export type GetProductTagsShopProductsTagsGetResponse =
  GetProductTagsShopProductsTagsGetResponses[keyof GetProductTagsShopProductsTagsGetResponses]

export type CreateProductTagShopProductsTagsPostData = {
  body: ProductTagIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/shop/products/tags'
}

export type CreateProductTagShopProductsTagsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateProductTagShopProductsTagsPostError =
  CreateProductTagShopProductsTagsPostErrors[keyof CreateProductTagShopProductsTagsPostErrors]

export type CreateProductTagShopProductsTagsPostResponses = {
  /**
   * Successful Response
   */
  201: ProductTagOut
}

export type CreateProductTagShopProductsTagsPostResponse =
  CreateProductTagShopProductsTagsPostResponses[keyof CreateProductTagShopProductsTagsPostResponses]

export type DeleteProductTagShopProductsTagsProductTagIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Tag Id
     */
    product_tag_id: number
  }
  query?: never
  url: '/shop/products/tags/{product_tag_id}'
}

export type DeleteProductTagShopProductsTagsProductTagIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteProductTagShopProductsTagsProductTagIdDeleteError =
  DeleteProductTagShopProductsTagsProductTagIdDeleteErrors[keyof DeleteProductTagShopProductsTagsProductTagIdDeleteErrors]

export type DeleteProductTagShopProductsTagsProductTagIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteProductTagShopProductsTagsProductTagIdDeleteResponse =
  DeleteProductTagShopProductsTagsProductTagIdDeleteResponses[keyof DeleteProductTagShopProductsTagsProductTagIdDeleteResponses]

export type UpdateProductTagShopProductsTagsProductTagIdPutData = {
  body: ProductTagIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Tag Id
     */
    product_tag_id: number
  }
  query?: never
  url: '/shop/products/tags/{product_tag_id}'
}

export type UpdateProductTagShopProductsTagsProductTagIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateProductTagShopProductsTagsProductTagIdPutError =
  UpdateProductTagShopProductsTagsProductTagIdPutErrors[keyof UpdateProductTagShopProductsTagsProductTagIdPutErrors]

export type UpdateProductTagShopProductsTagsProductTagIdPutResponses = {
  /**
   * Successful Response
   */
  200: ProductTagOut
}

export type UpdateProductTagShopProductsTagsProductTagIdPutResponse =
  UpdateProductTagShopProductsTagsProductTagIdPutResponses[keyof UpdateProductTagShopProductsTagsProductTagIdPutResponses]

export type ListProductLabelsShopProductsLabelsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/shop/products/labels'
}

export type ListProductLabelsShopProductsLabelsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListProductLabelsShopProductsLabelsGetError =
  ListProductLabelsShopProductsLabelsGetErrors[keyof ListProductLabelsShopProductsLabelsGetErrors]

export type ListProductLabelsShopProductsLabelsGetResponses = {
  /**
   * Successful Response
   */
  200: ProductLabelsOut
}

export type ListProductLabelsShopProductsLabelsGetResponse =
  ListProductLabelsShopProductsLabelsGetResponses[keyof ListProductLabelsShopProductsLabelsGetResponses]

export type CreateProductLabelShopProductsLabelsPostData = {
  body: ProductLabelIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/shop/products/labels'
}

export type CreateProductLabelShopProductsLabelsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateProductLabelShopProductsLabelsPostError =
  CreateProductLabelShopProductsLabelsPostErrors[keyof CreateProductLabelShopProductsLabelsPostErrors]

export type CreateProductLabelShopProductsLabelsPostResponses = {
  /**
   * Successful Response
   */
  201: ProductLabelOut
}

export type CreateProductLabelShopProductsLabelsPostResponse =
  CreateProductLabelShopProductsLabelsPostResponses[keyof CreateProductLabelShopProductsLabelsPostResponses]

export type DeleteProductLabelShopProductsLabelsProductLabelIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Label Id
     */
    product_label_id: number
  }
  query?: never
  url: '/shop/products/labels/{product_label_id}'
}

export type DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteProductLabelShopProductsLabelsProductLabelIdDeleteError =
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors[keyof DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors]

export type DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponse =
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses[keyof DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses]

export type UpdateProductLabelShopProductsLabelsProductLabelIdPutData = {
  body: ProductLabelUpdateIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Label Id
     */
    product_label_id: number
  }
  query?: never
  url: '/shop/products/labels/{product_label_id}'
}

export type UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateProductLabelShopProductsLabelsProductLabelIdPutError =
  UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors[keyof UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors]

export type UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses = {
  /**
   * Successful Response
   */
  200: ProductLabelOut
}

export type UpdateProductLabelShopProductsLabelsProductLabelIdPutResponse =
  UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses[keyof UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses]

export type CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostData = {
  body: ProductReviewIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Order Id
     */
    order_id: number
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/orders/{order_id}/products/{product_id}/reviews'
}

export type CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostError =
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors[keyof CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors]

export type CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses = {
  /**
   * Successful Response
   */
  201: ProductReviewOut
}

export type CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponse =
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses[keyof CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses]

export type ListProductReviewsShopProductsProductIdReviewsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: {
    /**
     * Per Page
     */
    per_page?: number
    /**
     * Page
     */
    page?: number
  }
  url: '/shop/products/{product_id}/reviews'
}

export type ListProductReviewsShopProductsProductIdReviewsGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListProductReviewsShopProductsProductIdReviewsGetError =
  ListProductReviewsShopProductsProductIdReviewsGetErrors[keyof ListProductReviewsShopProductsProductIdReviewsGetErrors]

export type ListProductReviewsShopProductsProductIdReviewsGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type ListReviewsAdminShopReviewsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Per Page
     */
    per_page?: number
    /**
     * Page
     */
    page?: number
    status?: ProductReviewStatusEnum
    /**
     * Product Id
     */
    product_id?: number
    /**
     * Rating
     */
    rating?: number
    /**
     * Date From
     */
    date_from?: string
    /**
     * Date To
     */
    date_to?: string
  }
  url: '/shop/reviews'
}

export type ListReviewsAdminShopReviewsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListReviewsAdminShopReviewsGetError =
  ListReviewsAdminShopReviewsGetErrors[keyof ListReviewsAdminShopReviewsGetErrors]

export type ListReviewsAdminShopReviewsGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetReviewAdminShopReviewsReviewIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Review Id
     */
    review_id: number
  }
  query?: never
  url: '/shop/reviews/{review_id}'
}

export type GetReviewAdminShopReviewsReviewIdGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetReviewAdminShopReviewsReviewIdGetError =
  GetReviewAdminShopReviewsReviewIdGetErrors[keyof GetReviewAdminShopReviewsReviewIdGetErrors]

export type GetReviewAdminShopReviewsReviewIdGetResponses = {
  /**
   * Successful Response
   */
  200: ProductReviewAdminOut
}

export type GetReviewAdminShopReviewsReviewIdGetResponse =
  GetReviewAdminShopReviewsReviewIdGetResponses[keyof GetReviewAdminShopReviewsReviewIdGetResponses]

export type ApproveProductReviewShopReviewsReviewIdApprovePutData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Review Id
     */
    review_id: number
  }
  query?: never
  url: '/shop/reviews/{review_id}/approve'
}

export type ApproveProductReviewShopReviewsReviewIdApprovePutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ApproveProductReviewShopReviewsReviewIdApprovePutError =
  ApproveProductReviewShopReviewsReviewIdApprovePutErrors[keyof ApproveProductReviewShopReviewsReviewIdApprovePutErrors]

export type ApproveProductReviewShopReviewsReviewIdApprovePutResponses = {
  /**
   * Successful Response
   */
  200: ProductReviewAdminOut
}

export type ApproveProductReviewShopReviewsReviewIdApprovePutResponse =
  ApproveProductReviewShopReviewsReviewIdApprovePutResponses[keyof ApproveProductReviewShopReviewsReviewIdApprovePutResponses]

export type RejectProductReviewShopReviewsReviewIdRejectPutData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Review Id
     */
    review_id: number
  }
  query?: never
  url: '/shop/reviews/{review_id}/reject'
}

export type RejectProductReviewShopReviewsReviewIdRejectPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type RejectProductReviewShopReviewsReviewIdRejectPutError =
  RejectProductReviewShopReviewsReviewIdRejectPutErrors[keyof RejectProductReviewShopReviewsReviewIdRejectPutErrors]

export type RejectProductReviewShopReviewsReviewIdRejectPutResponses = {
  /**
   * Successful Response
   */
  200: ProductReviewAdminOut
}

export type RejectProductReviewShopReviewsReviewIdRejectPutResponse =
  RejectProductReviewShopReviewsReviewIdRejectPutResponses[keyof RejectProductReviewShopReviewsReviewIdRejectPutResponses]

export type GetProductsShopProductsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Per Page
     */
    per_page?: number
    /**
     * Page
     */
    page?: number
    order?: OrderDirectionEnum
    sort?: SortByEnum
    /**
     * Query
     */
    query?: string | null
    /**
     * Tag Ids
     */
    tag_ids?: Array<number>
    /**
     * Label Ids
     */
    label_ids?: Array<number>
    /**
     * All Locations
     */
    all_locations?: boolean
    /**
     * Deleted
     */
    deleted?: boolean
  }
  url: '/shop/products'
}

export type GetProductsShopProductsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetProductsShopProductsGetError = GetProductsShopProductsGetErrors[keyof GetProductsShopProductsGetErrors]

export type GetProductsShopProductsGetResponses = {
  /**
   * Successful Response
   */
  200: ProductsOut
}

export type GetProductsShopProductsGetResponse =
  GetProductsShopProductsGetResponses[keyof GetProductsShopProductsGetResponses]

export type CreateProductShopProductsPostData = {
  body: ProductIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/shop/products'
}

export type CreateProductShopProductsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateProductShopProductsPostError =
  CreateProductShopProductsPostErrors[keyof CreateProductShopProductsPostErrors]

export type CreateProductShopProductsPostResponses = {
  /**
   * Successful Response
   */
  201: ProductOutFull
}

export type CreateProductShopProductsPostResponse =
  CreateProductShopProductsPostResponses[keyof CreateProductShopProductsPostResponses]

export type DeleteProductShopProductsProductIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/products/{product_id}'
}

export type DeleteProductShopProductsProductIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteProductShopProductsProductIdDeleteError =
  DeleteProductShopProductsProductIdDeleteErrors[keyof DeleteProductShopProductsProductIdDeleteErrors]

export type DeleteProductShopProductsProductIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteProductShopProductsProductIdDeleteResponse =
  DeleteProductShopProductsProductIdDeleteResponses[keyof DeleteProductShopProductsProductIdDeleteResponses]

export type GetProductShopProductsProductIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/products/{product_id}'
}

export type GetProductShopProductsProductIdGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetProductShopProductsProductIdGetError =
  GetProductShopProductsProductIdGetErrors[keyof GetProductShopProductsProductIdGetErrors]

export type GetProductShopProductsProductIdGetResponses = {
  /**
   * Successful Response
   */
  200: ProductOutFull
}

export type GetProductShopProductsProductIdGetResponse =
  GetProductShopProductsProductIdGetResponses[keyof GetProductShopProductsProductIdGetResponses]

export type UpdateProductShopProductsProductIdPutData = {
  body: ProductIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/products/{product_id}'
}

export type UpdateProductShopProductsProductIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateProductShopProductsProductIdPutError =
  UpdateProductShopProductsProductIdPutErrors[keyof UpdateProductShopProductsProductIdPutErrors]

export type UpdateProductShopProductsProductIdPutResponses = {
  /**
   * Successful Response
   */
  200: ProductOutFull
}

export type UpdateProductShopProductsProductIdPutResponse =
  UpdateProductShopProductsProductIdPutResponses[keyof UpdateProductShopProductsProductIdPutResponses]

export type UpdateProductStockShopProductsProductIdStockPutData = {
  body: ProductStockIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/products/{product_id}/stock'
}

export type UpdateProductStockShopProductsProductIdStockPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateProductStockShopProductsProductIdStockPutError =
  UpdateProductStockShopProductsProductIdStockPutErrors[keyof UpdateProductStockShopProductsProductIdStockPutErrors]

export type UpdateProductStockShopProductsProductIdStockPutResponses = {
  /**
   * Successful Response
   */
  200: ProductStockOut
}

export type UpdateProductStockShopProductsProductIdStockPutResponse =
  UpdateProductStockShopProductsProductIdStockPutResponses[keyof UpdateProductStockShopProductsProductIdStockPutResponses]

export type ExportStockExcelShopExportStockGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * With Zero Stock
     */
    with_zero_stock?: boolean
  }
  url: '/shop/export-stock'
}

export type ExportStockExcelShopExportStockGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ExportStockExcelShopExportStockGetError =
  ExportStockExcelShopExportStockGetErrors[keyof ExportStockExcelShopExportStockGetErrors]

export type ExportStockExcelShopExportStockGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type RestoreProductShopProductsProductIdRestorePutData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Product Id
     */
    product_id: number
  }
  query?: never
  url: '/shop/products/{product_id}/restore'
}

export type RestoreProductShopProductsProductIdRestorePutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type RestoreProductShopProductsProductIdRestorePutError =
  RestoreProductShopProductsProductIdRestorePutErrors[keyof RestoreProductShopProductsProductIdRestorePutErrors]

export type RestoreProductShopProductsProductIdRestorePutResponses = {
  /**
   * Successful Response
   */
  200: ProductOutFull
}

export type RestoreProductShopProductsProductIdRestorePutResponse =
  RestoreProductShopProductsProductIdRestorePutResponses[keyof RestoreProductShopProductsProductIdRestorePutResponses]

export type GetDeliveryAddressShopDeliveryAddressUserIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * User Id
     */
    user_id: string
  }
  query?: never
  url: '/shop/delivery-address/{user_id}'
}

export type GetDeliveryAddressShopDeliveryAddressUserIdGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetDeliveryAddressShopDeliveryAddressUserIdGetError =
  GetDeliveryAddressShopDeliveryAddressUserIdGetErrors[keyof GetDeliveryAddressShopDeliveryAddressUserIdGetErrors]

export type GetDeliveryAddressShopDeliveryAddressUserIdGetResponses = {
  /**
   * Successful Response
   */
  200: DeliveryAddressOut
}

export type GetDeliveryAddressShopDeliveryAddressUserIdGetResponse =
  GetDeliveryAddressShopDeliveryAddressUserIdGetResponses[keyof GetDeliveryAddressShopDeliveryAddressUserIdGetResponses]

export type UpsertDeliveryAddressShopDeliveryAddressUserIdPostData = {
  body: DeliveryAddressIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * User Id
     */
    user_id: string
  }
  query?: never
  url: '/shop/delivery-address/{user_id}'
}

export type UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpsertDeliveryAddressShopDeliveryAddressUserIdPostError =
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors[keyof UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors]

export type UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses = {
  /**
   * Successful Response
   */
  200: DeliveryAddressOut
}

export type UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponse =
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses[keyof UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses]

export type GetOrdersShopOrdersGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Date From
     */
    date_from?: string | null
    /**
     * Date To
     */
    date_to?: string | null
    current_order_state?: OrderStateEnum
    /**
     * Per Page
     */
    per_page?: number
    /**
     * Page
     */
    page?: number
    order?: OrderDirectionEnum
    /**
     * Return All
     */
    return_all?: boolean
    /**
     * Query
     */
    query?: string | null
  }
  url: '/shop/orders'
}

export type GetOrdersShopOrdersGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetOrdersShopOrdersGetError = GetOrdersShopOrdersGetErrors[keyof GetOrdersShopOrdersGetErrors]

export type GetOrdersShopOrdersGetResponses = {
  /**
   * Successful Response
   */
  200: OrdersOut
}

export type GetOrdersShopOrdersGetResponse = GetOrdersShopOrdersGetResponses[keyof GetOrdersShopOrdersGetResponses]

export type BuyProductShopOrdersPostData = {
  body: OrderIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/shop/orders'
}

export type BuyProductShopOrdersPostErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type BuyProductShopOrdersPostError = BuyProductShopOrdersPostErrors[keyof BuyProductShopOrdersPostErrors]

export type BuyProductShopOrdersPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type ExportOrdersExcelShopOrdersExportGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query: {
    /**
     * Date From
     */
    date_from: string
    /**
     * Date To
     */
    date_to: string
    current_order_state?: OrderStateEnum
  }
  url: '/shop/orders/export'
}

export type ExportOrdersExcelShopOrdersExportGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ExportOrdersExcelShopOrdersExportGetError =
  ExportOrdersExcelShopOrdersExportGetErrors[keyof ExportOrdersExcelShopOrdersExportGetErrors]

export type ExportOrdersExcelShopOrdersExportGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetOrderStatesShopOrdersOrderIdStatesGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Order Id
     */
    order_id: number
  }
  query?: never
  url: '/shop/orders/{order_id}/states'
}

export type GetOrderStatesShopOrdersOrderIdStatesGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetOrderStatesShopOrdersOrderIdStatesGetError =
  GetOrderStatesShopOrdersOrderIdStatesGetErrors[keyof GetOrderStatesShopOrdersOrderIdStatesGetErrors]

export type GetOrderStatesShopOrdersOrderIdStatesGetResponses = {
  /**
   * Successful Response
   */
  200: OrderStatesOut
}

export type GetOrderStatesShopOrdersOrderIdStatesGetResponse =
  GetOrderStatesShopOrdersOrderIdStatesGetResponses[keyof GetOrderStatesShopOrdersOrderIdStatesGetResponses]

export type SetOrderStateShopOrdersOrderIdStatesPostData = {
  body: OrderStateIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path: {
    /**
     * Order Id
     */
    order_id: number
  }
  query?: never
  url: '/shop/orders/{order_id}/states'
}

export type SetOrderStateShopOrdersOrderIdStatesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SetOrderStateShopOrdersOrderIdStatesPostError =
  SetOrderStateShopOrdersOrderIdStatesPostErrors[keyof SetOrderStateShopOrdersOrderIdStatesPostErrors]

export type SetOrderStateShopOrdersOrderIdStatesPostResponses = {
  /**
   * Successful Response
   */
  201: OrderStatesOut
}

export type SetOrderStateShopOrdersOrderIdStatesPostResponse =
  SetOrderStateShopOrdersOrderIdStatesPostResponses[keyof SetOrderStateShopOrdersOrderIdStatesPostResponses]

export type SetOrderTrackCodeShopOrdersOrderIdTrackCodePostData = {
  body: SetOrderTrackCodeIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Order Id
     */
    order_id: number
  }
  query?: never
  url: '/shop/orders/{order_id}/track-code'
}

export type SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SetOrderTrackCodeShopOrdersOrderIdTrackCodePostError =
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors[keyof SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors]

export type SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses = {
  /**
   * Successful Response
   */
  201: OrderOut
}

export type SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponse =
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses[keyof SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses]

export type CancelOrderShopOrdersOrderIdCancelPostData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path: {
    /**
     * Order Id
     */
    order_id: number
  }
  query?: never
  url: '/shop/orders/{order_id}/cancel'
}

export type CancelOrderShopOrdersOrderIdCancelPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CancelOrderShopOrdersOrderIdCancelPostError =
  CancelOrderShopOrdersOrderIdCancelPostErrors[keyof CancelOrderShopOrdersOrderIdCancelPostErrors]

export type CancelOrderShopOrdersOrderIdCancelPostResponses = {
  /**
   * Successful Response
   */
  200: OrderStatesOut
}

export type CancelOrderShopOrdersOrderIdCancelPostResponse =
  CancelOrderShopOrdersOrderIdCancelPostResponses[keyof CancelOrderShopOrdersOrderIdCancelPostResponses]

export type GetBalanceAccountBalanceGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/balance'
}

export type GetBalanceAccountBalanceGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetBalanceAccountBalanceGetError =
  GetBalanceAccountBalanceGetErrors[keyof GetBalanceAccountBalanceGetErrors]

export type GetBalanceAccountBalanceGetResponses = {
  /**
   * Successful Response
   */
  200: AccountBalanceOut
}

export type GetBalanceAccountBalanceGetResponse =
  GetBalanceAccountBalanceGetResponses[keyof GetBalanceAccountBalanceGetResponses]

export type GetUsersBalanceAccountBalanceUsersGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query: {
    /**
     * Users Ids
     */
    users_ids: Array<string>
  }
  url: '/account/balance/users'
}

export type GetUsersBalanceAccountBalanceUsersGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUsersBalanceAccountBalanceUsersGetError =
  GetUsersBalanceAccountBalanceUsersGetErrors[keyof GetUsersBalanceAccountBalanceUsersGetErrors]

export type GetUsersBalanceAccountBalanceUsersGetResponses = {
  /**
   * Successful Response
   */
  200: AccountBalancesOut
}

export type GetUsersBalanceAccountBalanceUsersGetResponse =
  GetUsersBalanceAccountBalanceUsersGetResponses[keyof GetUsersBalanceAccountBalanceUsersGetResponses]

export type GetUserBalanceAccountBalanceUserUserIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * User Id
     */
    user_id: string
  }
  query?: never
  url: '/account/balance/user/{user_id}'
}

export type GetUserBalanceAccountBalanceUserUserIdGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUserBalanceAccountBalanceUserUserIdGetError =
  GetUserBalanceAccountBalanceUserUserIdGetErrors[keyof GetUserBalanceAccountBalanceUserUserIdGetErrors]

export type GetUserBalanceAccountBalanceUserUserIdGetResponses = {
  /**
   * Successful Response
   */
  200: AccountBalanceOut
}

export type GetUserBalanceAccountBalanceUserUserIdGetResponse =
  GetUserBalanceAccountBalanceUserUserIdGetResponses[keyof GetUserBalanceAccountBalanceUserUserIdGetResponses]

export type GetHistoryAccountHistoryGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/history'
}

export type GetHistoryAccountHistoryGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetHistoryAccountHistoryGetError =
  GetHistoryAccountHistoryGetErrors[keyof GetHistoryAccountHistoryGetErrors]

export type GetHistoryAccountHistoryGetResponses = {
  /**
   * Successful Response
   */
  200: BillingHistoryOut
}

export type GetHistoryAccountHistoryGetResponse =
  GetHistoryAccountHistoryGetResponses[keyof GetHistoryAccountHistoryGetResponses]

export type TransferCoinsAccountBalanceTransferPostData = {
  body: TransferIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/account/balance/transfer'
}

export type TransferCoinsAccountBalanceTransferPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type TransferCoinsAccountBalanceTransferPostError =
  TransferCoinsAccountBalanceTransferPostErrors[keyof TransferCoinsAccountBalanceTransferPostErrors]

export type TransferCoinsAccountBalanceTransferPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type AddCoinsAccountBalanceAddPostData = {
  body: CoinsAddIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/account/balance/add'
}

export type AddCoinsAccountBalanceAddPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AddCoinsAccountBalanceAddPostError =
  AddCoinsAccountBalanceAddPostErrors[keyof AddCoinsAccountBalanceAddPostErrors]

export type AddCoinsAccountBalanceAddPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type DebitCoinsAccountBalanceDebitPostData = {
  body: CoinsDebitIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/account/balance/debit'
}

export type DebitCoinsAccountBalanceDebitPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DebitCoinsAccountBalanceDebitPostError =
  DebitCoinsAccountBalanceDebitPostErrors[keyof DebitCoinsAccountBalanceDebitPostErrors]

export type DebitCoinsAccountBalanceDebitPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type BulkAddCoinsAccountBalanceBulkAddPostData = {
  body: BulkCoinsAddIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/balance/bulk-add'
}

export type BulkAddCoinsAccountBalanceBulkAddPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type BulkAddCoinsAccountBalanceBulkAddPostError =
  BulkAddCoinsAccountBalanceBulkAddPostErrors[keyof BulkAddCoinsAccountBalanceBulkAddPostErrors]

export type BulkAddCoinsAccountBalanceBulkAddPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type ImportValidateAccountBalanceImportValidatePostData = {
  body: BodyImportValidateAccountBalanceImportValidatePost
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/balance/import/validate'
}

export type ImportValidateAccountBalanceImportValidatePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ImportValidateAccountBalanceImportValidatePostError =
  ImportValidateAccountBalanceImportValidatePostErrors[keyof ImportValidateAccountBalanceImportValidatePostErrors]

export type ImportValidateAccountBalanceImportValidatePostResponses = {
  /**
   * Successful Response
   */
  200: CoinsImportResult
}

export type ImportValidateAccountBalanceImportValidatePostResponse =
  ImportValidateAccountBalanceImportValidatePostResponses[keyof ImportValidateAccountBalanceImportValidatePostResponses]

export type ImportConfirmAccountBalanceImportConfirmPostData = {
  body: BodyImportConfirmAccountBalanceImportConfirmPost
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/balance/import/confirm'
}

export type ImportConfirmAccountBalanceImportConfirmPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ImportConfirmAccountBalanceImportConfirmPostError =
  ImportConfirmAccountBalanceImportConfirmPostErrors[keyof ImportConfirmAccountBalanceImportConfirmPostErrors]

export type ImportConfirmAccountBalanceImportConfirmPostResponses = {
  /**
   * Successful Response
   */
  200: CoinsImportResult
}

export type ImportConfirmAccountBalanceImportConfirmPostResponse =
  ImportConfirmAccountBalanceImportConfirmPostResponses[keyof ImportConfirmAccountBalanceImportConfirmPostResponses]

export type GetJournalAccountJournalGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Date From
     */
    date_from?: string | null
    /**
     * Date To
     */
    date_to?: string | null
    /**
     * Transaction Type
     */
    transaction_type?: TransactionTypeEnum | null
    /**
     * User Ids
     */
    user_ids?: Array<string>
    sort_by?: JournalSortByEnum
    sort_order?: OrderDirectionEnum
    /**
     * Limit
     */
    limit?: number
    /**
     * Offset
     */
    offset?: number
  }
  url: '/account/journal'
}

export type GetJournalAccountJournalGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetJournalAccountJournalGetError =
  GetJournalAccountJournalGetErrors[keyof GetJournalAccountJournalGetErrors]

export type GetJournalAccountJournalGetResponses = {
  /**
   * Successful Response
   */
  200: JournalListOut
}

export type GetJournalAccountJournalGetResponse =
  GetJournalAccountJournalGetResponses[keyof GetJournalAccountJournalGetResponses]

export type ExportJournalAccountJournalExportGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    format?: ExportFormatEnum
    /**
     * Date From
     */
    date_from?: string | null
    /**
     * Date To
     */
    date_to?: string | null
    /**
     * Transaction Type
     */
    transaction_type?: TransactionTypeEnum | null
    /**
     * User Ids
     */
    user_ids?: Array<string>
    sort_by?: JournalSortByEnum
    sort_order?: OrderDirectionEnum
    /**
     * Limit
     */
    limit?: number
    /**
     * Offset
     */
    offset?: number
  }
  url: '/account/journal/export'
}

export type ExportJournalAccountJournalExportGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ExportJournalAccountJournalExportGetError =
  ExportJournalAccountJournalExportGetErrors[keyof ExportJournalAccountJournalExportGetErrors]

export type ExportJournalAccountJournalExportGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetJournalDetailAccountJournalJournalRecordIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Journal Record Id
     */
    journal_record_id: number
  }
  query?: never
  url: '/account/journal/{journal_record_id}'
}

export type GetJournalDetailAccountJournalJournalRecordIdGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetJournalDetailAccountJournalJournalRecordIdGetError =
  GetJournalDetailAccountJournalJournalRecordIdGetErrors[keyof GetJournalDetailAccountJournalJournalRecordIdGetErrors]

export type GetJournalDetailAccountJournalJournalRecordIdGetResponses = {
  /**
   * Successful Response
   */
  200: JournalRecordOut
}

export type GetJournalDetailAccountJournalJournalRecordIdGetResponse =
  GetJournalDetailAccountJournalJournalRecordIdGetResponses[keyof GetJournalDetailAccountJournalJournalRecordIdGetResponses]

export type GetImportTemplateAccountBalanceImportTemplateGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/account/balance/import/template'
}

export type GetImportTemplateAccountBalanceImportTemplateGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetImportTemplateAccountBalanceImportTemplateGetError =
  GetImportTemplateAccountBalanceImportTemplateGetErrors[keyof GetImportTemplateAccountBalanceImportTemplateGetErrors]

export type GetImportTemplateAccountBalanceImportTemplateGetResponses = {
  /**
   * XLSX template
   */
  200: Blob | File
}

export type GetImportTemplateAccountBalanceImportTemplateGetResponse =
  GetImportTemplateAccountBalanceImportTemplateGetResponses[keyof GetImportTemplateAccountBalanceImportTemplateGetResponses]

export type GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/feedback/categories/emails'
}

export type GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetError =
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors[keyof GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors]

export type GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses = {
  /**
   * Successful Response
   */
  200: FeedbackEmailsInOut
}

export type GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponse =
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses[keyof GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses]

export type SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutData = {
  body: FeedbackEmailsInOut
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/feedback/categories/emails'
}

export type SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutError =
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors[keyof SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors]

export type SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses = {
  /**
   * Successful Response
   */
  200: FeedbackEmailsInOut
}

export type SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponse =
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses[keyof SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses]

export type GetFeedbackCategoriesFeedbackCategoriesGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/feedback/categories'
}

export type GetFeedbackCategoriesFeedbackCategoriesGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetFeedbackCategoriesFeedbackCategoriesGetError =
  GetFeedbackCategoriesFeedbackCategoriesGetErrors[keyof GetFeedbackCategoriesFeedbackCategoriesGetErrors]

export type GetFeedbackCategoriesFeedbackCategoriesGetResponses = {
  /**
   * Successful Response
   */
  200: FeedbackCategoriesOut
}

export type GetFeedbackCategoriesFeedbackCategoriesGetResponse =
  GetFeedbackCategoriesFeedbackCategoriesGetResponses[keyof GetFeedbackCategoriesFeedbackCategoriesGetResponses]

export type CreateFeedbackCategoryFeedbackCategoriesPostData = {
  body: FeedbackCategoryIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/feedback/categories'
}

export type CreateFeedbackCategoryFeedbackCategoriesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateFeedbackCategoryFeedbackCategoriesPostError =
  CreateFeedbackCategoryFeedbackCategoriesPostErrors[keyof CreateFeedbackCategoryFeedbackCategoriesPostErrors]

export type CreateFeedbackCategoryFeedbackCategoriesPostResponses = {
  /**
   * Successful Response
   */
  200: FeedbackCategoryOut
}

export type CreateFeedbackCategoryFeedbackCategoriesPostResponse =
  CreateFeedbackCategoryFeedbackCategoriesPostResponses[keyof CreateFeedbackCategoryFeedbackCategoriesPostResponses]

export type DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Feedback Category Id
     */
    feedback_category_id: number
  }
  query?: never
  url: '/feedback/categories/{feedback_category_id}'
}

export type DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteError =
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors[keyof DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors]

export type DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponse =
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses[keyof DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses]

export type UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutData = {
  body: FeedbackCategoryIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Feedback Category Id
     */
    feedback_category_id: number
  }
  query?: never
  url: '/feedback/categories/{feedback_category_id}'
}

export type UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutError =
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors[keyof UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors]

export type UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses = {
  /**
   * Successful Response
   */
  200: FeedbackCategoryOut
}

export type UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponse =
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses[keyof UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses]

export type SendFeedbackFeedbackSendPostData = {
  body: BodySendFeedbackFeedbackSendPost
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/feedback/send'
}

export type SendFeedbackFeedbackSendPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type SendFeedbackFeedbackSendPostError =
  SendFeedbackFeedbackSendPostErrors[keyof SendFeedbackFeedbackSendPostErrors]

export type SendFeedbackFeedbackSendPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetEventsEventsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: {
    /**
     * Page
     */
    page?: number
    /**
     * Per Page
     */
    per_page?: number
    order?: OrderDirectionEnum
    /**
     * Return All
     */
    return_all?: boolean
    /**
     * Query
     */
    query?: StrictQuery | null
  }
  url: '/events'
}

export type GetEventsEventsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetEventsEventsGetError = GetEventsEventsGetErrors[keyof GetEventsEventsGetErrors]

export type GetEventsEventsGetResponses = {
  /**
   * Successful Response
   */
  200: EventsOut
}

export type GetEventsEventsGetResponse = GetEventsEventsGetResponses[keyof GetEventsEventsGetResponses]

export type CreateEventEventsPostData = {
  body: EventInCreate
  headers?: {
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/events'
}

export type CreateEventEventsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateEventEventsPostError = CreateEventEventsPostErrors[keyof CreateEventEventsPostErrors]

export type CreateEventEventsPostResponses = {
  /**
   * Successful Response
   */
  201: EventOut
}

export type CreateEventEventsPostResponse = CreateEventEventsPostResponses[keyof CreateEventEventsPostResponses]

export type DeleteEventEventsEventIdDeleteData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path: {
    /**
     * Event Id
     */
    event_id: number
  }
  query?: never
  url: '/events/{event_id}'
}

export type DeleteEventEventsEventIdDeleteErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteEventEventsEventIdDeleteError =
  DeleteEventEventsEventIdDeleteErrors[keyof DeleteEventEventsEventIdDeleteErrors]

export type DeleteEventEventsEventIdDeleteResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type DeleteEventEventsEventIdDeleteResponse =
  DeleteEventEventsEventIdDeleteResponses[keyof DeleteEventEventsEventIdDeleteResponses]

export type GetEventEventsEventIdGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path: {
    /**
     * Event Id
     */
    event_id: number
  }
  query?: never
  url: '/events/{event_id}'
}

export type GetEventEventsEventIdGetErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetEventEventsEventIdGetError = GetEventEventsEventIdGetErrors[keyof GetEventEventsEventIdGetErrors]

export type GetEventEventsEventIdGetResponses = {
  /**
   * Successful Response
   */
  200: EventOut
}

export type GetEventEventsEventIdGetResponse =
  GetEventEventsEventIdGetResponses[keyof GetEventEventsEventIdGetResponses]

export type UpdateEventEventsEventIdPutData = {
  body: EventInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path: {
    /**
     * Event Id
     */
    event_id: number
  }
  query?: never
  url: '/events/{event_id}'
}

export type UpdateEventEventsEventIdPutErrors = {
  /**
   * Item not found
   */
  404: unknown
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateEventEventsEventIdPutError =
  UpdateEventEventsEventIdPutErrors[keyof UpdateEventEventsEventIdPutErrors]

export type UpdateEventEventsEventIdPutResponses = {
  /**
   * Successful Response
   */
  200: EventOut
}

export type UpdateEventEventsEventIdPutResponse =
  UpdateEventEventsEventIdPutResponses[keyof UpdateEventEventsEventIdPutResponses]

export type GetBrandConfigBrandingGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/branding'
}

export type GetBrandConfigBrandingGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetBrandConfigBrandingGetError = GetBrandConfigBrandingGetErrors[keyof GetBrandConfigBrandingGetErrors]

export type GetBrandConfigBrandingGetResponses = {
  /**
   * Successful Response
   */
  200: BrandConfigOut
}

export type GetBrandConfigBrandingGetResponse =
  GetBrandConfigBrandingGetResponses[keyof GetBrandConfigBrandingGetResponses]

export type UpdateBrandConfigBrandingPostData = {
  body: BrandConfigIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/branding'
}

export type UpdateBrandConfigBrandingPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateBrandConfigBrandingPostError =
  UpdateBrandConfigBrandingPostErrors[keyof UpdateBrandConfigBrandingPostErrors]

export type UpdateBrandConfigBrandingPostResponses = {
  /**
   * Successful Response
   */
  200: BrandConfigOut
}

export type UpdateBrandConfigBrandingPostResponse =
  UpdateBrandConfigBrandingPostResponses[keyof UpdateBrandConfigBrandingPostResponses]

export type CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostData = {
  body: DepartmentInCreate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreateDepartment'
}

export type CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostError =
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors[keyof CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors]

export type CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentOut
}

export type CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponse =
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses[keyof CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses]

export type ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostData = {
  body: ListChildDepartmentsRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListChildDepartments'
}

export type ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostError =
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors[keyof ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors]

export type ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentsOut
}

export type ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponse =
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses[keyof ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses]

export type GetDepartmentPassportIdmIdmPrivateGetDepartmentPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetDepartment'
}

export type GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetDepartmentPassportIdmIdmPrivateGetDepartmentPostError =
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors[keyof GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors]

export type GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentOut
}

export type GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponse =
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses[keyof GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses]

export type ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostData = {
  body: ListDepartmentsRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListDepartments'
}

export type ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostError =
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors[keyof ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors]

export type ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentsBaseOut
}

export type ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponse =
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses[keyof ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses]

export type DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostData = {
  body: IdVersionRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/DeleteDepartment'
}

export type DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostError =
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors[keyof DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors]

export type DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentOut
}

export type DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponse =
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses[keyof DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses]

export type UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostData = {
  body: DepartmentInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdateDepartment'
}

export type UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostError =
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors[keyof UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors]

export type UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentOut
}

export type UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponse =
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses[keyof UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses]

export type GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetDepartmentsTree'
}

export type GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostError =
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors[keyof GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors]

export type GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentsTreeOut
}

export type GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponse =
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses[keyof GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses]

export type GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetDepartmentBreadcrumbs'
}

export type GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostError =
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors[keyof GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors]

export type GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses = {
  /**
   * Successful Response
   */
  200: DepartmentsBaseOut
}

export type GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponse =
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses[keyof GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses]

export type CreateCityPassportIdmIdmPrivateCreateCityPostData = {
  body: CityInCreate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreateCity'
}

export type CreateCityPassportIdmIdmPrivateCreateCityPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateCityPassportIdmIdmPrivateCreateCityPostError =
  CreateCityPassportIdmIdmPrivateCreateCityPostErrors[keyof CreateCityPassportIdmIdmPrivateCreateCityPostErrors]

export type CreateCityPassportIdmIdmPrivateCreateCityPostResponses = {
  /**
   * Successful Response
   */
  200: CityOut
}

export type CreateCityPassportIdmIdmPrivateCreateCityPostResponse =
  CreateCityPassportIdmIdmPrivateCreateCityPostResponses[keyof CreateCityPassportIdmIdmPrivateCreateCityPostResponses]

export type CreateCountryPassportIdmIdmPrivateCreateCountryPostData = {
  body: CountryInCreate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreateCountry'
}

export type CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateCountryPassportIdmIdmPrivateCreateCountryPostError =
  CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors[keyof CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors]

export type CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses = {
  /**
   * Successful Response
   */
  200: CountryOut
}

export type CreateCountryPassportIdmIdmPrivateCreateCountryPostResponse =
  CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses[keyof CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses]

export type CreateOfficePassportIdmIdmPrivateCreateOfficePostData = {
  body: OfficeInCreate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreateOffice'
}

export type CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateOfficePassportIdmIdmPrivateCreateOfficePostError =
  CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors[keyof CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors]

export type CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses = {
  /**
   * Successful Response
   */
  200: OfficeOut
}

export type CreateOfficePassportIdmIdmPrivateCreateOfficePostResponse =
  CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses[keyof CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses]

export type DeleteCityPassportIdmIdmPrivateDeleteCityPostData = {
  body: IdVersionRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/DeleteCity'
}

export type DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteCityPassportIdmIdmPrivateDeleteCityPostError =
  DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors[keyof DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors]

export type DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses = {
  /**
   * Successful Response
   */
  200: CityOut
}

export type DeleteCityPassportIdmIdmPrivateDeleteCityPostResponse =
  DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses[keyof DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses]

export type DeleteCountryPassportIdmIdmPrivateDeleteCountryPostData = {
  body: IdVersionRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/DeleteCountry'
}

export type DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteCountryPassportIdmIdmPrivateDeleteCountryPostError =
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors[keyof DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors]

export type DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses = {
  /**
   * Successful Response
   */
  200: CountryOut
}

export type DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponse =
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses[keyof DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses]

export type DeleteOfficePassportIdmIdmPrivateDeleteOfficePostData = {
  body: IdVersionRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/DeleteOffice'
}

export type DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeleteOfficePassportIdmIdmPrivateDeleteOfficePostError =
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors[keyof DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors]

export type DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses = {
  /**
   * Successful Response
   */
  200: OfficeOut
}

export type DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponse =
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses[keyof DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses]

export type GetCityPassportIdmIdmPrivateGetCityPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetCity'
}

export type GetCityPassportIdmIdmPrivateGetCityPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCityPassportIdmIdmPrivateGetCityPostError =
  GetCityPassportIdmIdmPrivateGetCityPostErrors[keyof GetCityPassportIdmIdmPrivateGetCityPostErrors]

export type GetCityPassportIdmIdmPrivateGetCityPostResponses = {
  /**
   * Successful Response
   */
  200: CityOut
}

export type GetCityPassportIdmIdmPrivateGetCityPostResponse =
  GetCityPassportIdmIdmPrivateGetCityPostResponses[keyof GetCityPassportIdmIdmPrivateGetCityPostResponses]

export type GetCountryPassportIdmIdmPrivateGetCountryPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetCountry'
}

export type GetCountryPassportIdmIdmPrivateGetCountryPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCountryPassportIdmIdmPrivateGetCountryPostError =
  GetCountryPassportIdmIdmPrivateGetCountryPostErrors[keyof GetCountryPassportIdmIdmPrivateGetCountryPostErrors]

export type GetCountryPassportIdmIdmPrivateGetCountryPostResponses = {
  /**
   * Successful Response
   */
  200: CountryOut
}

export type GetCountryPassportIdmIdmPrivateGetCountryPostResponse =
  GetCountryPassportIdmIdmPrivateGetCountryPostResponses[keyof GetCountryPassportIdmIdmPrivateGetCountryPostResponses]

export type GetOfficePassportIdmIdmPrivateGetOfficePostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetOffice'
}

export type GetOfficePassportIdmIdmPrivateGetOfficePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetOfficePassportIdmIdmPrivateGetOfficePostError =
  GetOfficePassportIdmIdmPrivateGetOfficePostErrors[keyof GetOfficePassportIdmIdmPrivateGetOfficePostErrors]

export type GetOfficePassportIdmIdmPrivateGetOfficePostResponses = {
  /**
   * Successful Response
   */
  200: OfficeOut
}

export type GetOfficePassportIdmIdmPrivateGetOfficePostResponse =
  GetOfficePassportIdmIdmPrivateGetOfficePostResponses[keyof GetOfficePassportIdmIdmPrivateGetOfficePostResponses]

export type ListCitiesPassportIdmIdmPrivateListCitiesPostData = {
  body: CityInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListCities'
}

export type ListCitiesPassportIdmIdmPrivateListCitiesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListCitiesPassportIdmIdmPrivateListCitiesPostError =
  ListCitiesPassportIdmIdmPrivateListCitiesPostErrors[keyof ListCitiesPassportIdmIdmPrivateListCitiesPostErrors]

export type ListCitiesPassportIdmIdmPrivateListCitiesPostResponses = {
  /**
   * Successful Response
   */
  200: CitiesOut
}

export type ListCitiesPassportIdmIdmPrivateListCitiesPostResponse =
  ListCitiesPassportIdmIdmPrivateListCitiesPostResponses[keyof ListCitiesPassportIdmIdmPrivateListCitiesPostResponses]

export type ListCountriesPassportIdmIdmPrivateListCountriesPostData = {
  body: CountryInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListCountries'
}

export type ListCountriesPassportIdmIdmPrivateListCountriesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListCountriesPassportIdmIdmPrivateListCountriesPostError =
  ListCountriesPassportIdmIdmPrivateListCountriesPostErrors[keyof ListCountriesPassportIdmIdmPrivateListCountriesPostErrors]

export type ListCountriesPassportIdmIdmPrivateListCountriesPostResponses = {
  /**
   * Successful Response
   */
  200: CountriesOut
}

export type ListCountriesPassportIdmIdmPrivateListCountriesPostResponse =
  ListCountriesPassportIdmIdmPrivateListCountriesPostResponses[keyof ListCountriesPassportIdmIdmPrivateListCountriesPostResponses]

export type ListOfficesPassportIdmIdmPrivateListOfficesPostData = {
  body: OfficeInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListOffices'
}

export type ListOfficesPassportIdmIdmPrivateListOfficesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListOfficesPassportIdmIdmPrivateListOfficesPostError =
  ListOfficesPassportIdmIdmPrivateListOfficesPostErrors[keyof ListOfficesPassportIdmIdmPrivateListOfficesPostErrors]

export type ListOfficesPassportIdmIdmPrivateListOfficesPostResponses = {
  /**
   * Successful Response
   */
  200: OfficesOut
}

export type ListOfficesPassportIdmIdmPrivateListOfficesPostResponse =
  ListOfficesPassportIdmIdmPrivateListOfficesPostResponses[keyof ListOfficesPassportIdmIdmPrivateListOfficesPostResponses]

export type UpdateCityPassportIdmIdmPrivateUpdateCityPostData = {
  body: CityInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdateCity'
}

export type UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateCityPassportIdmIdmPrivateUpdateCityPostError =
  UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors[keyof UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors]

export type UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses = {
  /**
   * Successful Response
   */
  200: CityOut
}

export type UpdateCityPassportIdmIdmPrivateUpdateCityPostResponse =
  UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses[keyof UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses]

export type UpdateCountryPassportIdmIdmPrivateUpdateCountryPostData = {
  body: CountryInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdateCountry'
}

export type UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateCountryPassportIdmIdmPrivateUpdateCountryPostError =
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors[keyof UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors]

export type UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses = {
  /**
   * Successful Response
   */
  200: CountryOut
}

export type UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponse =
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses[keyof UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses]

export type UpdateOfficePassportIdmIdmPrivateUpdateOfficePostData = {
  body: OfficeInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdateOffice'
}

export type UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateOfficePassportIdmIdmPrivateUpdateOfficePostError =
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors[keyof UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors]

export type UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses = {
  /**
   * Successful Response
   */
  200: OfficeOut
}

export type UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponse =
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses[keyof UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses]

export type GetPositionPassportIdmIdmPrivateGetPositionPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/GetPosition'
}

export type GetPositionPassportIdmIdmPrivateGetPositionPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetPositionPassportIdmIdmPrivateGetPositionPostError =
  GetPositionPassportIdmIdmPrivateGetPositionPostErrors[keyof GetPositionPassportIdmIdmPrivateGetPositionPostErrors]

export type GetPositionPassportIdmIdmPrivateGetPositionPostResponses = {
  /**
   * Successful Response
   */
  200: PositionOut
}

export type GetPositionPassportIdmIdmPrivateGetPositionPostResponse =
  GetPositionPassportIdmIdmPrivateGetPositionPostResponses[keyof GetPositionPassportIdmIdmPrivateGetPositionPostResponses]

export type ListPositionsPassportIdmIdmPrivateListPositionsPostData = {
  body: PositionsRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ListPositions'
}

export type ListPositionsPassportIdmIdmPrivateListPositionsPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListPositionsPassportIdmIdmPrivateListPositionsPostError =
  ListPositionsPassportIdmIdmPrivateListPositionsPostErrors[keyof ListPositionsPassportIdmIdmPrivateListPositionsPostErrors]

export type ListPositionsPassportIdmIdmPrivateListPositionsPostResponses = {
  /**
   * Successful Response
   */
  200: PositionsOut
}

export type ListPositionsPassportIdmIdmPrivateListPositionsPostResponse =
  ListPositionsPassportIdmIdmPrivateListPositionsPostResponses[keyof ListPositionsPassportIdmIdmPrivateListPositionsPostResponses]

export type CreatePositionPassportIdmIdmPrivateCreatePositionPostData = {
  body: PositionCreateIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreatePosition'
}

export type CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreatePositionPassportIdmIdmPrivateCreatePositionPostError =
  CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors[keyof CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors]

export type CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses = {
  /**
   * Successful Response
   */
  200: PositionOut
}

export type CreatePositionPassportIdmIdmPrivateCreatePositionPostResponse =
  CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses[keyof CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses]

export type UpdatePositionPassportIdmIdmPrivateUpdatePositionPostData = {
  body: PositionUpdateIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdatePosition'
}

export type UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdatePositionPassportIdmIdmPrivateUpdatePositionPostError =
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors[keyof UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors]

export type UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses = {
  /**
   * Successful Response
   */
  200: PositionOut
}

export type UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponse =
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses[keyof UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses]

export type DeletePositionPassportIdmIdmPrivateDeletePositionPostData = {
  body: IdVersionRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/DeletePosition'
}

export type DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type DeletePositionPassportIdmIdmPrivateDeletePositionPostError =
  DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors[keyof DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors]

export type DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses = {
  /**
   * Successful Response
   */
  200: PositionOut
}

export type DeletePositionPassportIdmIdmPrivateDeletePositionPostResponse =
  DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses[keyof DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses]

export type CreateUserPassportIdmIdmPrivateCreateUserPostData = {
  body: UserInCreate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/CreateUser'
}

export type CreateUserPassportIdmIdmPrivateCreateUserPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CreateUserPassportIdmIdmPrivateCreateUserPostError =
  CreateUserPassportIdmIdmPrivateCreateUserPostErrors[keyof CreateUserPassportIdmIdmPrivateCreateUserPostErrors]

export type CreateUserPassportIdmIdmPrivateCreateUserPostResponses = {
  /**
   * Successful Response
   */
  200: UserProfileRoleOut
}

export type CreateUserPassportIdmIdmPrivateCreateUserPostResponse =
  CreateUserPassportIdmIdmPrivateCreateUserPostResponses[keyof CreateUserPassportIdmIdmPrivateCreateUserPostResponses]

export type UpdateUserPassportIdmIdmPrivateUpdateUserPostData = {
  body: UserInUpdate
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UpdateUser'
}

export type UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateUserPassportIdmIdmPrivateUpdateUserPostError =
  UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors[keyof UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors]

export type UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses = {
  /**
   * Successful Response
   */
  200: UserProfileRoleOut
}

export type UpdateUserPassportIdmIdmPrivateUpdateUserPostResponse =
  UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses[keyof UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses]

export type BlockUserPassportIdmIdmPrivateBlockUserPostData = {
  body: UserInBlock
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/BlockUser'
}

export type BlockUserPassportIdmIdmPrivateBlockUserPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type BlockUserPassportIdmIdmPrivateBlockUserPostError =
  BlockUserPassportIdmIdmPrivateBlockUserPostErrors[keyof BlockUserPassportIdmIdmPrivateBlockUserPostErrors]

export type BlockUserPassportIdmIdmPrivateBlockUserPostResponses = {
  /**
   * Successful Response
   */
  200: UserProfileRoleOut
}

export type BlockUserPassportIdmIdmPrivateBlockUserPostResponse =
  BlockUserPassportIdmIdmPrivateBlockUserPostResponses[keyof BlockUserPassportIdmIdmPrivateBlockUserPostResponses]

export type UnblockUserPassportIdmIdmPrivateUnblockUserPostData = {
  body: UserInUnblock
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/UnblockUser'
}

export type UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UnblockUserPassportIdmIdmPrivateUnblockUserPostError =
  UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors[keyof UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors]

export type UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses = {
  /**
   * Successful Response
   */
  200: UserProfileRoleOut
}

export type UnblockUserPassportIdmIdmPrivateUnblockUserPostResponse =
  UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses[keyof UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses]

export type ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostData = {
  body: BodyImportEmployeesPassportIdmIdmPrivateImportEmployeesPost
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
    /**
     * X-Session-Id
     */
    'x-session-id'?: number | null
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ImportEmployees'
}

export type ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostError =
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors[keyof ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors]

export type ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.IdmPrivate/ImportEmployees/Template'
}

export type GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetError =
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors[keyof GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors]

export type GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type GetTenantBonusesConfigsTenantBonusesGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/bonuses'
}

export type GetTenantBonusesConfigsTenantBonusesGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetTenantBonusesConfigsTenantBonusesGetError =
  GetTenantBonusesConfigsTenantBonusesGetErrors[keyof GetTenantBonusesConfigsTenantBonusesGetErrors]

export type GetTenantBonusesConfigsTenantBonusesGetResponses = {
  /**
   * Successful Response
   */
  200: TenantBonusesConfigsOut
}

export type GetTenantBonusesConfigsTenantBonusesGetResponse =
  GetTenantBonusesConfigsTenantBonusesGetResponses[keyof GetTenantBonusesConfigsTenantBonusesGetResponses]

export type UpdateTenantRefillsConfigTenantBonusesPostData = {
  body: UpdateTenantBonusesRowIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/bonuses'
}

export type UpdateTenantRefillsConfigTenantBonusesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateTenantRefillsConfigTenantBonusesPostError =
  UpdateTenantRefillsConfigTenantBonusesPostErrors[keyof UpdateTenantRefillsConfigTenantBonusesPostErrors]

export type UpdateTenantRefillsConfigTenantBonusesPostResponses = {
  /**
   * Successful Response
   */
  200: TenantBonusesRowOut
}

export type UpdateTenantRefillsConfigTenantBonusesPostResponse =
  UpdateTenantRefillsConfigTenantBonusesPostResponses[keyof UpdateTenantRefillsConfigTenantBonusesPostResponses]

export type GetTenantServicesConfigTenantServicesGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/services'
}

export type GetTenantServicesConfigTenantServicesGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetTenantServicesConfigTenantServicesGetError =
  GetTenantServicesConfigTenantServicesGetErrors[keyof GetTenantServicesConfigTenantServicesGetErrors]

export type GetTenantServicesConfigTenantServicesGetResponses = {
  /**
   * Successful Response
   */
  200: TenantServicesConfigOut
}

export type GetTenantServicesConfigTenantServicesGetResponse =
  GetTenantServicesConfigTenantServicesGetResponses[keyof GetTenantServicesConfigTenantServicesGetResponses]

export type UpdateTenantServicesConfigTenantServicesPostData = {
  body: UpdateTenantServicesRowIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/services'
}

export type UpdateTenantServicesConfigTenantServicesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateTenantServicesConfigTenantServicesPostError =
  UpdateTenantServicesConfigTenantServicesPostErrors[keyof UpdateTenantServicesConfigTenantServicesPostErrors]

export type UpdateTenantServicesConfigTenantServicesPostResponses = {
  /**
   * Successful Response
   */
  200: TenantServicesConfigOut
}

export type UpdateTenantServicesConfigTenantServicesPostResponse =
  UpdateTenantServicesConfigTenantServicesPostResponses[keyof UpdateTenantServicesConfigTenantServicesPostResponses]

export type GetTenantPortalConfigTenantPortalGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/portal'
}

export type GetTenantPortalConfigTenantPortalGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetTenantPortalConfigTenantPortalGetError =
  GetTenantPortalConfigTenantPortalGetErrors[keyof GetTenantPortalConfigTenantPortalGetErrors]

export type GetTenantPortalConfigTenantPortalGetResponses = {
  /**
   * Successful Response
   */
  200: PortalConfigOut
}

export type GetTenantPortalConfigTenantPortalGetResponse =
  GetTenantPortalConfigTenantPortalGetResponses[keyof GetTenantPortalConfigTenantPortalGetResponses]

export type UpdateTenantPortalConfigTenantPortalPostData = {
  body: UpdatePortalConfigIn
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/tenant/portal'
}

export type UpdateTenantPortalConfigTenantPortalPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UpdateTenantPortalConfigTenantPortalPostError =
  UpdateTenantPortalConfigTenantPortalPostErrors[keyof UpdateTenantPortalConfigTenantPortalPostErrors]

export type UpdateTenantPortalConfigTenantPortalPostResponses = {
  /**
   * Successful Response
   */
  200: PortalConfigOut
}

export type UpdateTenantPortalConfigTenantPortalPostResponse =
  UpdateTenantPortalConfigTenantPortalPostResponses[keyof UpdateTenantPortalConfigTenantPortalPostResponses]

export type GetCityInfoPassportIdmIdmGetCityInfoPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/GetCityInfo'
}

export type GetCityInfoPassportIdmIdmGetCityInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCityInfoPassportIdmIdmGetCityInfoPostError =
  GetCityInfoPassportIdmIdmGetCityInfoPostErrors[keyof GetCityInfoPassportIdmIdmGetCityInfoPostErrors]

export type GetCityInfoPassportIdmIdmGetCityInfoPostResponses = {
  /**
   * Successful Response
   */
  200: CityOutInfo
}

export type GetCityInfoPassportIdmIdmGetCityInfoPostResponse =
  GetCityInfoPassportIdmIdmGetCityInfoPostResponses[keyof GetCityInfoPassportIdmIdmGetCityInfoPostResponses]

export type GetCountryInfoPassportIdmIdmGetCountryInfoPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/GetCountryInfo'
}

export type GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCountryInfoPassportIdmIdmGetCountryInfoPostError =
  GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors[keyof GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors]

export type GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses = {
  /**
   * Successful Response
   */
  200: CountryOutInfo
}

export type GetCountryInfoPassportIdmIdmGetCountryInfoPostResponse =
  GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses[keyof GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses]

export type GetOfficeInfoPassportIdmIdmGetOfficeInfoPostData = {
  body: IdRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/GetOfficeInfo'
}

export type GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetOfficeInfoPassportIdmIdmGetOfficeInfoPostError =
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors[keyof GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors]

export type GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses = {
  /**
   * Successful Response
   */
  200: OfficeOutInfo
}

export type GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponse =
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses[keyof GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses]

export type ListCitiesInfoPassportIdmIdmListCitiesInfoPostData = {
  body: CityInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/ListCitiesInfo'
}

export type ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListCitiesInfoPassportIdmIdmListCitiesInfoPostError =
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors[keyof ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors]

export type ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses = {
  /**
   * Successful Response
   */
  200: CitiesOutInfo
}

export type ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponse =
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses[keyof ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses]

export type ListCountriesInfoPassportIdmIdmListCountriesInfoPostData = {
  body: CountryInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/ListCountriesInfo'
}

export type ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListCountriesInfoPassportIdmIdmListCountriesInfoPostError =
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors[keyof ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors]

export type ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses = {
  /**
   * Successful Response
   */
  200: CountriesOutInfo
}

export type ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponse =
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses[keyof ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses]

export type ListOfficesInfoPassportIdmIdmListOfficesInfoPostData = {
  body: OfficeInfoRequest
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/passport.idm.Idm/ListOfficesInfo'
}

export type ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type ListOfficesInfoPassportIdmIdmListOfficesInfoPostError =
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors[keyof ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors]

export type ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses = {
  /**
   * Successful Response
   */
  200: OfficesOutInfo
}

export type ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponse =
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses[keyof ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses]

export type GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Start Date
     *
     * Start date, automatically will be set to the start of the specified month.
     */
    start_date?: string
    /**
     * End Date
     *
     * End date, automatically will be set to the end of the specified month.
     */
    end_date?: string
  }
  url: '/statistics/coins/active/allocated/per-month'
}

export type GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetError =
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors[keyof GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors]

export type GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses = {
  /**
   * Successful Response
   */
  200: CoinsPerMonthList
}

export type GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponse =
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses[keyof GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses]

export type GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/statistics/coins/usable/current-sum'
}

export type GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetError =
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors[keyof GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors]

export type GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses = {
  /**
   * Successful Response
   */
  200: CurrentUsableCount
}

export type GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponse =
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses[keyof GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses]

export type GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Page
     */
    page?: number
    /**
     * Per Page
     */
    per_page?: number
  }
  url: '/statistics/coins/usable/per-user'
}

export type GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetError =
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors[keyof GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors]

export type GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses = {
  /**
   * Successful Response
   */
  200: CoinsPerUserList
}

export type GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponse =
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses[keyof GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses]

export type GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Start Date
     *
     * Start date, automatically will be set to the start of the specified month.
     */
    start_date?: string
    /**
     * End Date
     *
     * End date, automatically will be set to the end of the specified month.
     */
    end_date?: string
  }
  url: '/statistics/coins/spent/per-month'
}

export type GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetError =
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors[keyof GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors]

export type GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses = {
  /**
   * Successful Response
   */
  200: CoinsPerMonthList
}

export type GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponse =
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses[keyof GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses]

export type GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Start Date
     *
     * Start date, automatically will be set to the start of the specified month.
     */
    start_date?: string
    /**
     * End Date
     *
     * End date, automatically will be set to the end of the specified month.
     */
    end_date?: string
  }
  url: '/statistics/coins/usable-avarage/per-month'
}

export type GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetError =
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors[keyof GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors]

export type GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses = {
  /**
   * Successful Response
   */
  200: CoinsPerMonthList
}

export type GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponse =
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses[keyof GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses]

export type GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Start Date
     *
     * Start date, automatically will be set to the start of the specified month.
     */
    start_date?: string
    /**
     * End Date
     *
     * End date, automatically will be set to the end of the specified month.
     */
    end_date?: string
  }
  url: '/statistics/coins/user-engagement/per-month'
}

export type GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetError =
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors[keyof GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors]

export type GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses = {
  /**
   * Successful Response
   */
  200: UserEngagementPerMonthList
}

export type GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponse =
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses[keyof GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses]

export type GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: {
    /**
     * Start Date
     *
     * Start date, automatically will be set to the start of the specified month.
     */
    start_date?: string
    /**
     * End Date
     *
     * End date, automatically will be set to the end of the specified month.
     */
    end_date?: string
  }
  url: '/statistics/coins/transfer-stats/per-month'
}

export type GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetError =
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors[keyof GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors]

export type GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses = {
  /**
   * Successful Response
   */
  200: TransferStatsPerMonthList
}

export type GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponse =
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses[keyof GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses]

export type UploadImageMediaUploadPostData = {
  body: BodyUploadImageMediaUploadPost
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path?: never
  query?: never
  url: '/media/upload'
}

export type UploadImageMediaUploadPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UploadImageMediaUploadPostError = UploadImageMediaUploadPostErrors[keyof UploadImageMediaUploadPostErrors]

export type UploadImageMediaUploadPostResponses = {
  /**
   * Successful Response
   */
  200: UploadImageResponse
}

export type UploadImageMediaUploadPostResponse =
  UploadImageMediaUploadPostResponses[keyof UploadImageMediaUploadPostResponses]

export type GetImageProxyMediaIdImgproxyProcessingOptionsGetData = {
  body?: never
  headers?: {
    /**
     * Tenant-Slug
     */
    'tenant-slug'?: string
  }
  path: {
    /**
     * Media Id
     */
    media_id: string
    /**
     * Imgproxy Processing Options
     */
    imgproxy_processing_options: string
  }
  query?: never
  url: '/proxy/{media_id}{imgproxy_processing_options}'
}

export type GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type GetImageProxyMediaIdImgproxyProcessingOptionsGetError =
  GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors[keyof GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors]

export type GetImageProxyMediaIdImgproxyProcessingOptionsGetResponses = {
  /**
   * Successful Response
   */
  200: unknown
}
